window.theme = window.theme || {};
window.slate = window.slate || {};

/* ================ SLATE ================ */
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = []; 

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */
slate.rte = {
  wrapTable: function() {
    $('.rte:first').find('table.amz_spec_table.narrow-table').wrapAll('<div class="rte__table-wrapper narrow table"></div>');
    $('.rte:first').find('table.amz_spec_table').wrapAll('<div class="rte__table-wrapper table"></div>');
    $('.rte table[border]').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
    );
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match === null) {
      return null;
    } else {
      return match[1];
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
	this.singleOptionSelector2 = options.singleOptionSelector2;

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
    $(this.singleOptionSelector2).on(
      'click',
      	this._onSelectChange2.bind(this)
    );

  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },
 	_getCurrentOptions2: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector2, this.$container),
        function(element) {
          var $element = $(element).find("label.actived+input");
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
              currentOption.value = $element.attr('value');
              currentOption.index = $element.data('index');
            	return currentOption;
          }
        }
      );
      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);
      return currentOptions;
    },
    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },
    _getVariantFromOptions2: function() {
      var selectedValues = this._getCurrentOptions2();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });
      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this._updateInventory(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },
    /**
     * 经分析，该函数会在产品页变更变体时触发
     */ 
    _onSelectChange2: function() {
      var variant = this._getVariantFromOptions2();
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this._updateInventory(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },
    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },
  /**
     * Trigger event when variant inventory changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateInventory: function(variant) {
      if (variant.inventory_quantity === this.currentVariant.inventory_quantity) {
        return;
      }

      this.$container.trigger({
        type: 'variantInventoryChange',
        variant: variant
      });
    },
    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/*================ MODULES ================*/
window.Drawers = (function() {
  var Drawer = function(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('body, html'),
      $page: $('.page-element'),
      $moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);
    this.$open = $(this.config.open);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function() {
    this.$open.attr('aria-expanded', 'false');
    this.$open.on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened drawer
    if (this.drawerIsOpen) {
      return;
    }

    this.$open.addClass(this.config.openClass);

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.nodes.$moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Drawer.prototype.close = function() {
    // don't close a closed drawer
    if (!this.drawerIsOpen) {
      return;
    }

    this.$open.removeClass(this.config.openClass);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.nodes.$moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    // Clicking out of drawer closes it
    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
    $("#NavDrawer .drawer__inner .close-toggle-btn").click(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );

    // Pressing escape closes drawer
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

theme.Hero = (function() {
  var selectors = {
    hero: '.hero',
    heroWrapper: '.hero-wrapper',
    heroArrows: '.hero__arrow',
    heroImage: '.hero__image',
    heroPause: '.hero__pause'
  };

  function Hero() {
    this.namespace = '.hero';
    this.$hero = $(selectors.hero);
    this.$hero.on('init' + this.namespace, this._a11y.bind(this));
    this.$hero.on('init' + this.namespace, this._arrowsInit.bind(this));

    this.$hero.slick({
      accessibility: true,
      arrows: false, // this theme has custom arrows
      draggable: false,
      autoplay: this.$hero.data('autoplay'),
      autoplaySpeed: this.$hero.data('speed')
    });

    $(selectors.heroImage).on(
      'click' + this.namespace,
      function() {
        this.$hero.slick('slickNext');
      }.bind(this)
    );

    $(selectors.heroPause).on(
      'click' + this.namespace,
      function() {
        if ($(selectors.heroPause).hasClass('is-paused')) {
          this._play();
        } else {
          this._pause();
        }
      }.bind(this)
    );
  }

  Hero.prototype = _.assignIn({}, Hero.prototype, {
    _pause: function() {
      this.$hero.slick('slickPause');
      $(selectors.heroPause).addClass('is-paused');
    },

    _play: function() {
      this.$hero.slick('slickPlay');
      $(selectors.heroPause).removeClass('is-paused');
    },

    _a11y: function(event, obj) {
      var $list = obj.$list;

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused
      // pause slideshow and set aria-live
      $(selectors.heroWrapper).on(
        'focusin' + this.namespace,
        function(evt) {
          if (!$(selectors.heroWrapper).has(evt.target).length) {
            return;
          }

          $list.attr('aria-live', 'polite');
          this._pause();
        }.bind(this)
      );

      // Resume autoplay
      $(selectors.heroWrapper).on(
        'focusout' + this.namespace,
        function(evt) {
          if (!$(selectors.heroWrapper).has(evt.target).length) {
            return;
          }

          $list.removeAttr('aria-live');
          this._play();
        }.bind(this)
      );
    },

    _arrowsInit: function(event, obj) {
      // Slider is initialized. Setup custom arrows
      var count = obj.slideCount;
      var $slider = obj.$slider;
      var $arrows = $(selectors.heroArrows);

      if ($arrows.length && count > 1) {
        $arrows.on(
          'click' + this.namespace,
          function(evt) {
            evt.preventDefault();
            if ($(evt.currentTarget).hasClass('hero__arrow--prev')) {
              $slider.slick('slickPrev');
            } else {
              $slider.slick('slickNext');
            }

            this._scrollTop();
          }.bind(this)
        );
      } else {
        $arrows.remove();
      }
    },

    _scrollTop: function() {
      var currentScroll = $(document).scrollTop();
      var heroOffset = this.$hero.offset().top;

      if (currentScroll > heroOffset) {
        $('html')
          .add('body')
          .animate(
            {
              scrollTop: heroOffset
            },
            250
          );
      }
    },

    goToSlide: function(slideIndex) {
      this.$hero.slick('slickGoTo', slideIndex);
    },

    pause: function() {
      this.$hero.slick('slickPause');
    },

    play: function() {
      this.$hero.slick('slickPlay');
    },

    destroy: function() {
      this.$hero.off(this.namespace);
      $(selectors.heroImage).off(this.namespace);
      $(selectors.heroPause).off(this.namespace);
      $(selectors.heroWrapper).off(this.namespace);
      $(selectors.heroArrows).off(this.namespace);

      this.$hero.slick('unslick');
    }
  });

  return Hero;
})();

window.Modals = (function() {
  var Modal = function(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $body: $('body')
    };

    this.config = $.extend(defaults, options);

    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen
      ? $(this.config.focusOnOpen)
      : this.$modal;
    this.init();
  };

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      return this.close();
    }

    this.$modal.prepareTransition().addClass(this.config.openClass);
    this.nodes.$body.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      $container: this.$modal,
      namespace: 'modal_focus',
      $elementToFocus: this.$focusOnOpen
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.prepareTransition().removeClass(this.config.openClass);
    this.nodes.$body.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$body.on(
      'keyup.modal',
      $.proxy(function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this)
    );
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$body.off('.modal');
  };

  return Modal;
})();

window.Meganav = (function() {
  var Meganav = function(options) {
    this.cache = {
      $document: $(document),
      $page: $('.page-element')
    };

    var defaults = {
      $meganavs: $('.meganav'),
      $megaNav: $('.meganav__nav'),
      $meganavToggle: $('.meganav-toggle'),
      $meganavThirdToggle: $('.site-nav__item'),
      $meganavDropdownContainers: $('.site-nav__dropdown-container'),
      $meganavToggleThirdLevel: $('.meganav__link-toggle'),
      $meganavLinkSecondLevel: $('.meganav__link--second-level'),
      $meganavLinkThirdLevel: $('.meganav__link--third-level'),
      $meganavDropdownThirdLevel: $('.site-nav__dropdown--third-level'),
      $meganavTarget:'',
      isOpen: false,
      preventDuplicates: false,
      closeOnPageClick: false,
      closeThirdLevelOnBlur: false,
      activeClass: 'meganav--active',
      drawerClass: 'meganav--drawer',
      meganavDropdown: '.site-nav__dropdown',
      drawerToggleClass: 'drawer__nav-toggle-btn',
      drawerNavItem: '.drawer__nav-item',
      navCollectionClass: 'meganav__nav--collection',
      thirdLevelClass: 'meganav__link-toggle',
      noAnimationClass: 'meganav--no-animation'
    };

    this.config = $.extend(defaults, options);
    this.init();
  };

  Meganav.prototype.init = function() {
    var $openBtn = this.config.$meganavToggle;
    var $closecont = this.config.$meganavThirdToggle;

    $openBtn.on('hover mouseover click', $.proxy(this.requestMeganav, this));
    $closecont.on('mouseleave click', $.proxy(this.close, this));

    /*if (this.config.closeThirdLevelOnBlur) {
      this.config.$meganavLinkThirdLevel.on(
        'blur',
        $.proxy(this.closeThirdLevelMenu, this)
      );
    }*/
    
    
  };

  Meganav.prototype.requestMeganav = function(evt) {
    var $targetedMeganav="";

    // Prevent following href if link is clicked
   /* if (evt) {
      evt.preventDefault();
    }*/

    // Without this, the meganav opens, the click event bubbles up to
    // theme.cache.$page which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
    }

    var $el = $(evt.currentTarget);
    var anotherNavIsOpen = this.config.isOpen;
    var isThirdLevelBtn = $el.hasClass(this.config.thirdLevelClass);

    // The $targetedMeganav is different for the drawer and non-drawer navs
    if ($el.hasClass(this.config.drawerToggleClass)) {
      $targetedMeganav = $el
        .closest(this.config.drawerNavItem)
        .children('.' + this.config.drawerClass);
    } else {
      $targetedMeganav = $el.siblings(this.config.meganavDropdown);
    }

    // Navigate to link href or close menu if already active
    if ($el.hasClass(this.config.activeClass) && $el.is('a')) {
      //window.location = $el.attr('href');
      return;
    }

    // If true, don't let multiple meganavs be open simultaneously
    if (!isThirdLevelBtn && this.config.preventDuplicates) {
      this.close();
    }

    if ($targetedMeganav.hasClass(this.config.drawerClass)) {
      var isExpanded = $el.attr('aria-expanded') === 'true';

      $el
        .toggleClass(this.config.activeClass)
        .attr('aria-expanded', !isExpanded);

      $targetedMeganav.stop().slideToggle(100);
    } else {
      $el.addClass(this.config.activeClass).attr('aria-expanded', 'true');

      // Show targeted nav, letting it know whether another meganav is already open
      this.open($el, $targetedMeganav, anotherNavIsOpen);
    }

    // Setup event handlers when meganav is open
    this.bindEvents();
    this.config.isOpen = true;

    // If dropdown has third level, calculate width for container
    var $dropdown = $el.next();
    var isCollection = $dropdown
      .find(this.config.$megaNav)
      .hasClass(this.config.navCollectionClass);

    if (isCollection) {
      this.updateThirdLevelContainerWidth($el, $dropdown);
    }
  };

  Meganav.prototype.updateThirdLevelContainerWidth = function($el, $dropdown) {
    var $thirdLevel = $dropdown.find(this.config.$meganavDropdownThirdLevel);

    if (!$thirdLevel.length) {
      return;
    }

    $.each(
      $thirdLevel,
      function(key, container) {
        var $container = $(container);
        var $lastChild = $container.find('li:last-child');

        this.updateContainerWidth($container, $lastChild);
      }.bind(this)
    );
  };

  Meganav.prototype.updateContainerWidth = function(container, element) {
    var containerRect = container[0].getBoundingClientRect();
    var elementRect = element[0].getBoundingClientRect();

    if (elementRect.left < containerRect.right) {
      return;
    }

    var columnWidth = containerRect.width;
    var containerFixedWidth =
      elementRect.left + columnWidth - containerRect.left;
    var numberOfColumns = containerFixedWidth / columnWidth;
    var containerPercentageWidth = numberOfColumns * 20;

    container
      .width(containerPercentageWidth + '%')
      .find('li')
      .css('width', 100 / numberOfColumns + '%');
  };

  Meganav.prototype.open = function($el, $target, noAnimation) {
    var isThirdLevelBtn = $el.hasClass(this.config.thirdLevelClass);
     this.config.$meganavTarget=$target;
    $target.addClass(this.config.activeClass);
    if (isThirdLevelBtn) {
      this.toggleSubNav($el, $target);
    }

    // Add class to override animation - CSS determined
    if (noAnimation) {
      $target.addClass(this.config.noAnimationClass);
    }
  };

  Meganav.prototype.toggleSubNav = function($el) {
    this.removeMenuActiveState();

    $el
      .addClass(this.config.activeClass)
      .attr('aria-expanded', 'true')
      .siblings(this.config.$meganavDropdownThirdLevel)
      .addClass(this.config.activeClass);

    $el.parent().addClass(this.config.activeClass);
  };

  Meganav.prototype.close = function(evt, $target) {
   $target=this.config.$meganavTarget;
    if (this.config.preventDuplicates) {;
      // Close all meganavs
      this.config.$meganavs.removeClass(
        [this.config.activeClass, this.config.noAnimationClass].join(' ')
      );
      this.config.$meganavToggle
        .removeClass(this.config.activeClass)
        .attr('aria-expanded', 'false');

      this.config.$meganavDropdownContainers.removeClass(
        this.config.activeClass
      );
    } else {      
      // Close targeted nav
//       var $targetedMeganav = $('#' + $target.attr('aria-controls'));
      
//       $targetedMeganav.removeClass(
//         [this.config.activeClass, this.config.noAnimationClass].join(' ')
//       );
//       $target
//         .removeClass(this.config.activeClass)
//         .attr('aria-expanded', 'false');
    }

    // Remove event listeners
    this.unbindEvents();
    this.config.isOpen = false;
  };

  Meganav.prototype.closeThirdLevelMenu = function(evt) {
    var $el = $(evt.currentTarget);
    var $parent = $el.parent();

    if (!$parent.is(':last-child')) {
      return;
    }

    this.config.$meganavLinkSecondLevel.one(
      'focus.meganav',
      $.proxy(function() {
        this.removeMenuActiveState();
      }, this)
    );
  };

  Meganav.prototype.removeMenuActiveState = function() {
    var activeClasses = [this.config.activeClass, this.config.noAnimationClass];

    this.config.$meganavToggleThirdLevel
      .removeClass(activeClasses.join(' '))
      .attr('aria-expanded', 'false');

    this.config.$meganavDropdownThirdLevel.removeClass(activeClasses.join(' '));
    this.config.$meganavDropdownContainers.removeClass(this.config.activeClass);
  };

  Meganav.prototype.bindEvents = function() {
    if (!this.config.closeOnPageClick) {
      return;
    }

    // Clicking away from the meganav will close it
    this.cache.$page.on('click.meganav', $.proxy(this.close, this));

    // Exception to above: clicking anywhere on the meganav will NOT close it
    this.config.$meganavs.on('click.meganav', function(evt) {
      evt.stopImmediatePropagation();
    });

    // Pressing escape closes meganav and focuses the target parent link
    this.cache.$document.on(
      'keyup.meganav',
      $.proxy(function(evt) {
        if (evt.keyCode !== 27) return;

        this.config.$meganavToggle
          .filter('.' + this.config.activeClass)
          .focus();
        //this.close();
      }, this)
    );
  };

  Meganav.prototype.unbindEvents = function() {
    if (!this.config.closeOnPageClick) {
      return;
    }

    this.cache.$page.off('.meganav');
    this.config.$meganavs.off('.meganav');
    this.cache.$document.off('.meganav');
    this.config.$meganavLinkSecondLevel.off('.meganav');
    this.config.$meganavLinkThirdLevel.off('.meganav');
  };

  return Meganav;
})();

window.QtySelector = (function() {
  var QtySelector = function($el) {
    this.cache = {
      $body: $('body'),
      $subtotal: $('#CartSubtotal'),
      $discountTotal: $('#cartDiscountTotal'),
      $cartTable: $('.cart-table'),
      $cartTemplate: $('#CartProducts')
    };

    this.settings = {
      loadingClass: 'js-qty--is-loading',
      isCartTemplate: this.cache.$body.hasClass('template-cart'),
      // On the cart template, minimum is 0. Elsewhere min is 1
      minQty: this.cache.$body.hasClass('template-cart') ? 0 : 1

    };

    

    this.$el = $el;
    this.qtyUpdateTimeout;
    this.createInputs();
    this.bindEvents();
  };

  QtySelector.prototype.createInputs = function() {
    var $el = this.$el;

    var data = {
      value: $el.val(),
      key: $el.attr('id'),
      name: $el.attr('name'),
      line: $el.attr('data-line')
    };
    var source = $('#QuantityTemplate').html();
    var template = Handlebars.compile(source);

    this.$wrapper = $(template(data)).insertBefore($el);

    // Remove original number input
    $el.remove();
  };

  QtySelector.prototype.validateAvailability = function(line, quantity) {
    var product = theme.cartObject.items[line - 1]; // 0-based index in API
    var handle = product.handle; // needed for the ajax request
    var id = product.id; // needed to find right variant from ajax results

    var params = {
      type: 'GET',
      url: '/products/' + handle + '.js',
      dataType: 'json',
      success: $.proxy(function(cartProduct) {
        this.validateAvailabilityCallback(line, quantity, id, cartProduct);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.validateAvailabilityCallback = function(
    line,
    quantity,
    id,
    product
  ) {
    var quantityIsAvailable = true;

    // This returns all variants of a product.
    // Loop through them to get our desired one.
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.id === id) {
        break;
      }
    }

    // If the variant tracks inventory and does not sell when sold out
    // we can compare the requested with available quantity
    if (
      variant.inventory_management !== null &&
      variant.inventory_policy === 'deny'
    ) {
      if (variant.inventory_quantity < quantity) {
        // Show notification with error message
      
        theme.Notify.open('error', theme.strings.noStockAvailable, true);
        

        // Set quantity to max amount available
        
        this.$wrapper.find('.js-qty__input').val(variant.inventory_quantity);

        quantityIsAvailable = false;
        this.$wrapper.removeClass(this.settings.loadingClass);
      }
    }

    if (quantityIsAvailable) {
      this.updateItemQuantity(line, quantity);
    }
  };

  QtySelector.prototype.validateQty = function(qty) {
    if (parseFloat(qty) === parseInt(qty, 10) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return parseInt(qty, 10);
  };

  /** 
   * 调整产品数量，点击输入框旁的加号和减号触发
   */
  QtySelector.prototype.adjustQty = function(evt) {
    var $el = $(evt.currentTarget);
    var $input = $el.siblings('.js-qty__input');
    var qty = this.validateQty($input.val());
    var line = $input.attr('data-line');
    
    var v_qty = $(".product-form__inventory").attr("data-maxqty");
    // console.log("QtySelector.prototype.adjustQty");
    // console.log("variant qty:" + v_qty);

    let clickTimer = 0
    function clickThrottle(qty) {
      let interval = 2000
        let now = +new Date(); 
        let timer = clickTimer; 
      
        if (now - timer < interval) {
       
            return false;
        } else { 
            clickTimer = now;
            $(".error-popup .popup-content").text("Error :  only "+ v_qty + " left in stock");
            $(".error-popup").fadeIn();
            return true;
        }
    }

    if ($el.hasClass('js-qty__adjust--minus')) {
      qty -= 1;
      if (qty <= this.settings.minQty) {
        qty = this.settings.minQty;
      }
    } else {
      qty += 1;
      
      if(qty > v_qty){
        qty = v_qty;
        clickThrottle(qty);
         setTimeout(function (){                     
              $(".error-popup").fadeOut();
              }, 5000);

      }

    }


    if (this.settings.isCartTemplate) {
      $el.parent().addClass(this.settings.loadingClass);
      this.updateCartItemPrice(line, qty);
    } else {
      $input.val(qty);
    }
  };

  QtySelector.prototype.bindEvents = function() {


    this.$wrapper
      .find('.js-qty__adjust')
      .on('click', $.proxy(this.adjustQty, this));

    // Select input text on click
    this.$wrapper.on('click', '.js-qty__input', function() {

      this.setSelectionRange(0, this.value.length);
    });

    this.$wrapper.on('change', '.js-qty__input', function(e) {
      // console.log(e.target.value);
     
      let qty = Number($(this).val());
      let v_qty = Number($(".product-form__inventory").attr("data-maxqty"));

      
    let clickTimer = 0
    function clickThrottle(qty) {
      let interval = 2000
        let now = +new Date(); 
        let timer = clickTimer; 
      
        if (now - timer < interval) {
       
            return false;
        } else { 
            clickTimer = now;
            $(".error-popup .popup-content").text("Error :  only "+ v_qty + " left in stock");
            $(".error-popup").fadeIn();
            return true;
        }
    }


      if(isNaN(qty)){
        $(this).val(1);
      } else if(qty > v_qty){
        qty = v_qty;
        clickThrottle(qty);
        $(this).val(qty);
         setTimeout(function (){                     
              $(".error-popup").fadeOut();
              }, 6000);

      }
    });

    // If the quantity changes on the cart template, update the price
    if (this.settings.isCartTemplate) {
      this.$wrapper.on(
        'change',
        '.js-qty__input',
        $.proxy(function(evt) {
          console.log("If the quantity changes on the cart template, update the price");
          var $input = $(evt.currentTarget);
          var line = $input.attr('data-line');
          var qty = this.validateQty($input.val());
          $input.parent().addClass(this.settings.loadingClass);
          this.updateCartItemPrice(line, qty);
        }, this)
      );
    }
  };

  QtySelector.prototype.updateCartItemPrice = function(line, qty) {
    // Update cart after short timeout so user doesn't create simultaneous ajax calls
    clearTimeout(this.qtyUpdateTimeout);
    this.qtyUpdateTimeout = setTimeout(
      $.proxy(function() {
        this.validateAvailability(line, qty);
      }, this),
      200
    );
  };

  QtySelector.prototype.updateItemQuantity = function(line, quantity) {
    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: $.proxy(function(cart) {
        this.updateCartItemCallback(cart);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.updateCartItemCallback = function(cart) {
    // Reload the page to show the empty cart if no items
    if (cart.item_count === 0) {
      location.reload();
      return;
    }

    // Update cart object
    theme.cartObject = cart;

    // Handlebars.js cart layout
    var data = {};
    var items = [];
    var item = {};
    var source = $('#CartProductTemplate').html();
    var template = Handlebars.compile(source);
    var prodImg;

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add 240x240, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */

      if (cartItem.image === null) {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      } else {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_240x240$1')
          .replace('http:', '');
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      // 不跟踪库存的情况下，以及跟踪库存但允许超额销售的情况下，开放无限库存（伪无限，9999）
      const isAllowInfinityShop = cartItem.inventory_management == null || (cartItem.inventory_management != null && cartItem.inventory_policy == 'continue');

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemQty: cartItem.quantity,
        itemMaxQty: isAllowInfinityShop ? 9999 : cartItem.inventory_quantity,
        price: theme.Currency.formatMoney(cartItem.price, theme.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: theme.Currency.formatMoney(
          cartItem.line_price,
          theme.moneyFormat
        ),
        originalLinePrice: theme.Currency.formatMoney(
          cartItem.original_line_price,
          theme.moneyFormat
        ),
        discounts: cartItem.discounts,
        discountsApplied:
          cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items
    };
    this.cache.$cartTemplate.empty().append(template(data));

    console.log("=======");
    console.log(data);
    console.log("=======");
    // Create new quantity selectors
    this.cache.$cartTable.find('input[type="number"]').each(function(i, el) {
      new QtySelector($(el));
    });

    // Update the cart subtotal
    this.cache.$subtotal.html(
      theme.Currency.formatMoney(cart.total_price, theme.moneyFormat)
    );

    // Update the cart total discounts
    if (cart.total_discount > 0) {
      this.cache.$discountTotal.html(
        theme.strings.totalCartDiscount.replace(
          '[savings]',
          theme.Currency.formatMoney(cart.total_discount, theme.moneyFormat)
        )
      );
    } else {
      this.cache.$discountTotal.empty();
    }

    // Set focus on cart table
    slate.a11y.pageLinkFocus(this.cache.$cartTable);
  };

  return QtySelector;
})();

/*
  Allow product to be added to cart via ajax with
  custom success and error responses.
*/
window.AjaxCart = (function() {
  var cart = function($form) {
    this.cache = {
      $cartIconIndicator: $('.site-header__cart-indicator')
    };

    this.$form = $form;
    this.eventListeners();
  };

  cart.prototype.eventListeners = function() {
    if (this.$form.length) {
      this.$form.on('submit', $.proxy(this.addItemFromForm, this));
    }
  };

  cart.prototype.addItemFromForm = function(evt) {
    evt.preventDefault();

    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: this.$form.serialize(),
      dataType: 'json',
      success: $.proxy(function(lineItem) {
        this.success(lineItem);
      }, this),
      error: $.proxy(function(XMLHttpRequest, textStatus) {
        this.error(XMLHttpRequest, textStatus);
      }, this)
    };

    $.ajax(params);
  };

  cart.prototype.success = function() {
    theme.Notify.open('success', false, true);
   alert("success");
    // Update cart notification bubble's state
    this.cache.$cartIconIndicator.removeClass('hide');
  };

  // Error handling reference from Shopify.onError in api.jquery.js
  cart.prototype.error = function(XMLHttpRequest) {
    var data = JSON.parse(XMLHttpRequest.responseText);

    if (data.message) {
      theme.Notify.open('error', data.description, true);
    }
  };

  return cart;
})();

window.Notify = (function() {
  var notify = function() {
    this.cache = {
      $scrollParent: $('html').add('body'),
      $notificationSuccess: $('#NotificationSuccess'),
      $notificationSuccessLink: $('#NotificationSuccess').find('a'),
      $notificationError: $('#NotificationError'),
      $notificationPromo: $('#NotificationPromo'),
      $notificationClose: $('.notification__close'),
      $notificationErrorMessage: $('.notification__message--error')
    };

    this.settings = {
      notifyActiveClass: 'notification--active',
      closeTimer: 5000,
      promoKeyName: 'promo-' + this.cache.$notificationPromo.data('text')
    };

    this.notifyTimer;
    this.$lastFocusedElement = null;

    this.isLocalStorageSupported = isLocalStorageSupported();

    this.cache.$notificationClose.on('click', this.close.bind(this));
    this.showPromo();
  };

  function isLocalStorageSupported() {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    try {
      var storage = window.sessionStorage;
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  notify.prototype.open = function(state, message, autoclose) {
    this.close();

    if (state === 'success') {
      this.cache.$notificationSuccess
        .attr('aria-hidden', false)
        .addClass(this.settings.notifyActiveClass);

      // Set last focused element to return to once success
      // notification is dismissed (by timeout)
      this.$lastFocusedElement = $(document.activeElement);

      // Set focus on link to cart after transition
      this.cache.$notificationSuccess.one(
        'TransitionEnd webkitTransitionEnd transitionend oTransitionEnd',
        $.proxy(function() {
          slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink);
        }, this)
      );

      // Fallback for no transitions
      if (this.cache.$scrollParent.hasClass('no-csstransitions')) {
        slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink);
      }
    } else {
      this.cache.$notificationErrorMessage.html(message);
      this.cache.$notificationError
        .attr('aria-hidden', false)
        .addClass(this.settings.notifyActiveClass);
    }

    // Timeout to close the notification
    if (autoclose) {
      clearTimeout(this.notifyTimer);
      this.notifyTimer = setTimeout(
        this.close.bind(this),
        this.settings.closeTimer
      );
    }
  };

  notify.prototype.close = function(evt) {
    if (evt && $(evt.currentTarget).attr('id') === 'NotificationPromoClose') {
      if (this.isLocalStorageSupported) {
        localStorage.setItem(this.settings.promoKeyName, 'hidden');
      }
    }

    // Return focus to previous element if one is defined
    // and the user has not strayed from the success notification link
    if (
      this.$lastFocusedElement &&
      this.cache.$notificationSuccessLink.is(':focus')
    ) {
      slate.a11y.pageLinkFocus(this.$lastFocusedElement);
    }

    // Close all notification bars
    this.cache.$notificationSuccess
      .attr('aria-hidden', true)
      .removeClass(this.settings.notifyActiveClass);
    this.cache.$notificationError
      .attr('aria-hidden', true)
      .removeClass(this.settings.notifyActiveClass);
    this.cache.$notificationPromo
      .attr('aria-hidden', true)
      .removeClass(this.settings.notifyActiveClass);

    // Reset last focused element
    this.$lastFocusedElement = null;
  };

  notify.prototype.showPromo = function(SFEevent) {
    // If reloaded in the storefront editor, update selectors/settings
    if (SFEevent) {
      this.initCache();
    }

    if (
      this.isLocalStorageSupported &&
      localStorage[this.settings.promoKeyName] === 'hidden'
    ) {
      return;
    }

    this.cache.$notificationPromo
      .attr('aria-hidden', false)
      .addClass(this.settings.notifyActiveClass);
  };

  return notify;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14,
    styles: [
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#cacaca' }, { lightness: 17 }]
      },
      {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [{ color: '#e1e1e1' }, { lightness: 20 }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [{ color: '#ffffff' }, { lightness: 17 }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }]
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [{ color: '#ffffff' }, { lightness: 18 }]
      },
      {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [{ color: '#ffffff' }, { lightness: 16 }]
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#e1e1e1' }, { lightness: 21 }]
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#bbbbbb' }, { lightness: 21 }]
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [{ visibility: 'on' }, { color: '#ffffff' }, { lightness: 16 }]
      },
      {
        elementType: 'labels.text.fill',
        stylers: [{ saturation: 36 }, { color: '#333333' }, { lightness: 40 }]
      },
      { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [{ color: '#f2f2f2' }, { lightness: 19 }]
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.fill',
        stylers: [{ color: '#fefefe' }, { lightness: 20 }]
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }]
      }
    ] // eslint-disable-line key-spacing, comma-spacing
  };
  var apiStatus = null;
  var mapsToLoad = [];

  function Map(container) {
    theme.$currentMapContainer = this.$container = $(container);
    var key = this.$container.data('api-key');

    if (typeof key !== 'string' || key === '') {
      return;
    }

    if (apiStatus === 'loaded') {
      var self = this;

      // Check if the script has previously been loaded with this key
      var $script = $('script[src*="' + key + '&"]');
      if ($script.length === 0) {
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + key
        ).then(function() {
          apiStatus = 'loaded';
          self.createMap();
        });
      } else {
        this.createMap();
      }
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              styles: config.styles,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());
            var enablePin = $map.data('enable-pin');

            var markerColor = $map.data('marker-color');

            var markerIcon = {
              path:
                'M57.7,0C25.8,0,0,25.8,0,57.7C0,89.5,50,170,57.7,170s57.7-80.5,57.7-112.3C115.3,25.8,89.5,0,57.7,0z M57.7,85 c-14.9,0-27-12.1-27-27c0-14.9,12.1-27,27-27c14.9,0,27,12.1,27,27C84.7,72.9,72.6,85,57.7,85z',
              fillColor: markerColor,
              fillOpacity: 0.9,
              scale: 0.2,
              strokeWeight: 0
            };

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: center,
              icon: markerIcon,
              visible: enablePin
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          // Only show error in the theme editor
          if (Shopify.designMode) {
            var $mapContainer = $map.parents('.map-section');

            $mapContainer.addClass('page-width map-section--load-error');
            $mapContainer.find('.map-section__content-wrapper').remove();
            $mapContainer
              .find('.map-section__wrapper')
              .html(
                '<div class="errors text-center" style="width: 100%;">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (typeof window.google !== 'undefined') {
        google.maps.event.clearListeners(this.map, 'resize');
      }
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  if (!Shopify.designMode) return;

  theme.$currentMapContainer.addClass('page-width map-section--load-error');
  theme.$currentMapContainer.find('.map-section__content-wrapper').remove();
  theme.$currentMapContainer
    .find('.map-section__wrapper')
    .html(
      '<div class="errors text-center" style="width: 100%;">' +
        theme.strings.authError +
        '</div>'
    );
}

theme.stickyHeader = (function() {
  var selectors = {
    searchCartWrapper: '#SiteNavSearchCart',
    stickyNavSearchCart: '#StickyNavSearchCart',
    stickyNavWrapper: '#StickNavWrapper',
    stickyBar: '#StickyBar'
  };

  var config = {
    lastScroll: 0,
    navClass: 'sticky--active',
    openTransitionClass: 'sticky--open',
    closeTransitionClass: 'sticky--close'
  };

  var cache = {};

  function cacheSelectors() {
    cache = {
      $window: $(window),
      $siteNavSearchCart: $(selectors.searchCartWrapper),
      $stickyBar: $(selectors.stickyBar)
    };
  }

  function init() {
    cacheSelectors();
    config.isActive = false;

    // Clone search/cart icons into fixed nav
    if (cache.$siteNavSearchCart.contents().length) {
      cache.$siteNavSearchCart
        .contents()
        .clone()
        .appendTo($(selectors.stickyNavSearchCart));
    }

    cache.$window.on('scroll.stickynav', $.throttle(15, stickyHeaderOnScroll));
  }

  function stickyHeaderOnScroll() {
    var scroll = cache.$window.scrollTop();
    var $el = $(selectors.stickyNavWrapper);
    var threshold = $el.offset().top + $el.height() ; 

       // Check if scrolling  
    if (scroll > threshold) {
      // Check if scrolling up 
    if (scroll < config.lastScroll) 
    {
      stickNav();
      $("#fsb_background").css("opacity",1);
      $("#fsb_background").addClass("10review-fsbheight");
      if($("#fsb_bar").length > 0 ){
        $("#shopify-section-anniversary-keibar-10th").css("margin-top","40px");
        $(".a10th-review-bar-div").css("margin-top","40px");
        $(".bfcm-section01-topbar").css("margin-top","40px");
      }
    }
    else
    {
      unstickNav();
      $("#fsb_background").css("opacity",0);
      $("#fsb_background").removeClass("10review-fsbheight");
      $("#shopify-section-anniversary-keibar-10th").css("margin-top","0");
      $(".a10th-review-bar-div").css("margin-top","0");
      $(".bfcm-section01-topbar").css("margin-top","0");
    }
      
    } else {
      // Check if scrolling dovn or back top 
      unstickNav();
       $("#fsb_background").css("opacity",1);
    }

    config.lastScroll = scroll;
  }

  function stickNav() {
    if (config.isActive) {
      return;
    }

    config.isActive = true;

    cache.$stickyBar.addClass(config.navClass);


    // Add open transition class after element is set to fixed
    // so CSS animation is applied correctly
    setTimeout(function() {
      cache.$stickyBar.addClass(config.openTransitionClass);
    }, 0);
    
  }

  function unstickNav() {
    if (!config.isActive) {
      return;
    }

    cache.$stickyBar
      .removeClass(config.openTransitionClass)
      .removeClass(config.navClass);
    
    

    config.isActive = false;
  }

  function unload() {
    $(window).off('.stickynav');
  }

  return {
    init: init,
    unload: unload
  };
})();

theme.headerNav = (function() {
  var selectors = {
    siteNav: '#SiteNav',
    siteNavCompressed: '#SiteNavCompressed',
    siteNavParent: '#SiteNavParent',
    siteNavItem: '.site-nav__item',
    stickyNavWrapper: '#StickNavWrapper',
    stickyNav: '#StickyNav',
    supportBg:'.support-bg'
  };

  var config = {
    lastScroll: 0,
    isActive: false,
    navClass: 'sticky--active',
    openTransitionClass: 'sticky--open',
    closeTransitionClass: 'sticky--close',
    searchShowClass: 'site-header__search-input--visible',
    searchInputClass: 'site-header__search-input',
    searchSubmitClass: 'site-header__search-submit',
    searchInnerActiveClass: 'search-header__search-inner--active'
  };

  function init() {
    sizeNav();
    initMegaNavs();
    initHeaderSearch();
    $(window).on('resize.headernav', $.debounce(250, sizeNav));
  }

  function sizeNav() {
    var navWidth = 0;
    var parentWidth = $(selectors.siteNavParent).width();
    var hideClass = 'hide';

    // Set height on nav-bar wrapper so when fixed, doesn't break layout
    $(selectors.stickyNavWrapper).height($(selectors.stickyNav).height());
    
    // Calculate the width of each nav item
    // after forcing them to be visible for the calculations
    $(selectors.siteNav).removeClass(hideClass);
    $(selectors.siteNavItem).each(function(i, el) {
      navWidth += $(el).width();
    });

//     if (navWidth > parentWidth) {
//       $(selectors.siteNav).addClass(hideClass);
//       $(selectors.siteNavCompressed).removeClass(hideClass);
//       $(selectors.supportBg).addClass(hideClass);
      
//     } else {
//       $(selectors.siteNav).removeClass(hideClass);
//       $(selectors.siteNavCompressed).addClass(hideClass);
//       $(selectors.supportBg).removeClass(hideClass);
//     }
  }

  function initMegaNavs() {
    new window.Meganav({
      $meganavs: $('.site-nav__dropdown'),
      $meganavToggle: $('.site-nav__link-toggle'),
      preventDuplicates: true,
      closeOnPageClick: true,
      closeThirdLevelOnBlur: true
    });

    new window.Meganav({
      $meganavs: $('.meganav--index'),
      $meganavToggle: $('.index__meganav-toggle')
    });

    new window.Meganav({
      $meganavs: $('.meganav--drawer'),
      $meganavToggle: $('.drawer__meganav-toggle')
    });
  }

  function initHeaderSearch() {
    // This function runs after the header search element
    // is duplicated into the sticky nav, meaning there are
    // two search fields to be aware of at this point.
    var $searchForm = $('.site-header__search');

    $searchForm.each(function(i, el) {
      var $form = $(el);
      var $input = $form.find('.' + config.searchInputClass);
      var $submit = $form.find('.' + config.searchSubmitClass);
      var $searchInner = $('.site-header__search-inner');

      $input.on('focus', function() {
        $searchInner.addClass(config.searchInnerActiveClass);
        $input.addClass(config.searchShowClass);
      });

      $input.on('blur', function() {
        $searchInner.removeClass(config.searchInnerActiveClass);
        if ($input.val()) {
          $input.addClass(config.searchShowClass);
        } else {
          $input.removeClass(config.searchShowClass);
        }
      });

      $submit.on('click', function(evt) {
        if ($input.hasClass(config.searchShowClass)) {
          return;
        }

        evt.preventDefault();
        $input.addClass(config.searchShowClass).focus();
      });
    });
  }

  function unload() {
    $(window).off('.stickynav');
  }

  return {
    init: init,
    unload: unload
  };
})();


/*================ TEMPLATES ================*/
theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    // check if reset password form was successfully submited
    if (!$('.reset-password-success').length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
theme.HeaderSection = (function() {
  function Header() {
    theme.stickyHeader.init();
    theme.headerNav.init();
    theme.Notify = new window.Notify();
    theme.NavDrawer = new window.Drawers('NavDrawer', 'left');
    drawerSearch();
  }

  function drawerSearch() {
    var $drawerSearch = $('.drawer__search-input');
    var $drawerSearchSubmit = $('.drawer__search-submit');

    $drawerSearchSubmit.on('click', function(evt) {
      if ($drawerSearch.val().length !== 0) {
        return;
      }

      evt.preventDefault();
      $drawerSearch.focus();
    });
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.stickyHeader.unload();
      theme.headerNav.unload();
    }
  });

  return Header;
})();

theme.Filters = (function() {
  var selectors = {
    filterSelection: '#SortTags',
    sortSelection: '#SortBy'
  };

  function Filters() {
    this.$filterSelect = $(selectors.filterSelection);
    this.$sortSelect = $(selectors.sortSelection);

    this.default = this._getDefaultSortValue();
    this.$sortSelect.val(this.default);

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _getDefaultSortValue: function() {
      return Shopify.queryParams.sort_by
        ? Shopify.queryParams.sort_by
        : this.$sortSelect.data('default-sort');
    },

    _onFilterChange: function() {
      delete Shopify.queryParams.page;
      if ($.isEmptyObject(Shopify.queryParams)) {
        location.href = this.$filterSelect.val();
      } else {
        location.href =
          this.$filterSelect.val() + '?' + $.param(Shopify.queryParams);
      }
    },

    _onSortChange: function() {
      Shopify.queryParams.sort_by = this.$sortSelect.val();
      location.search = $.param(Shopify.queryParams);
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

theme.Product = (function() {
  var defaults = {
    smallBreakpoint: 750, // copied from variables.scss
    productThumbIndex: 0,
    productThumbMax: 0,
    ajaxCart: false,
    stockSetting: false,
    stockSettingValue:10
  };

  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.selectors = {
      originalSelectorId: '#ProductSelect-' + sectionId,
      modal: 'ProductModal',
      productZoomImage: '#ProductZoomImg',
      addToCart: '#AddToCart-' + sectionId,
      productPrice: '#ProductPrice-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
       changechajia: '.save_money>span',
      addToCartText: '#AddToCartText-' + sectionId,
      SKU: '.variant-sku',
      inventoryBox:".inventory_quantity_box",
      inventory:".inventory_quantity",
      dataInventory:".product-form__inventory",
      addcartsho: '.product-form__cart-submit',
      productImageContainers: '.product__photo-container-' + sectionId,
      productImageWrappers: '.product__photo-wrapper-' + sectionId,
      productThumbContainers: '.product-single__thumbnail-item-' + sectionId,
      productThumbsWrapper: '.product-single__thumbnails-' + sectionId,
      productThumbs: '.product-single__thumbnail-' + sectionId,
      saleTag: '#ProductSaleTag',
      productStock: '#ProductStock-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      singleOptionSelector2: '.single-option-new-selector-' + sectionId,
      klaviyoBtn:'#klaviyo-product-bottom-position'
    };

    this.settings = $.extend({}, defaults, {
      sectionId: sectionId,
      ajaxCart: $container.data('ajax'),
      stockSettingValue: $container.data('stockSettingValue'),
      stockSetting: $container.data('stock'),
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.product-' + sectionId
    });

    // Stop parsing if we don't have the product json script tag
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      $('#ProductJson-' + sectionId).html()
    );
    this.addVariantInfo();

    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {
      this._stringOverrides();
      this._initVariants();
      this._productZoomImage();
      this._productThumbSwitch();
      this._productThumbnailSlider();
      this._initQtySelector();

      if (this.settings.ajaxCart) {
        theme.AjaxCart = new window.AjaxCart(
          $('#AddToCartForm-' + this.settings.sectionId)
        );
      }
    },

    _stringOverrides: function() {
      window.productStrings = window.productStrings || {};
      $.extend(theme.strings, window.productStrings);
    },

    addVariantInfo: function() {
      if (!this.productSingleObject || !this.settings.stockSetting) {
        return;
      }

      var variantInfo = JSON.parse(
        $('#VariantJson-' + this.settings.sectionId).html()
      );;
      for (var i = 0; i < variantInfo.length; i++) {
        $.extend(this.productSingleObject.variants[i], variantInfo[i]);
      }
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        product: this.productSingleObject,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        singleOptionSelector2: this.selectors.singleOptionSelector2
      };

      // eslint-disable-next-line no-new
      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCartBtn.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
      this.$container.on(
        'variantInventoryChange' + this.settings.namespace,
        this._updateInventory.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
    },

    _updateStock: function(variant) {
      if (!this.settings.stockSetting) return;
      var $stock = $(this.selectors.productStock);

      // If we don't track variant inventory, hide stock
      if (!variant || !variant.inventory_management) {
        $stock.addClass('hide');
        return;
      }

      if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0) {
        $stock
          .html(
            theme.strings.stockAvailable.replace(
              '1',
              variant.inventory_quantity
            )
          )
          .removeClass('hide');
        return;
      }

      if (variant.inventory_quantity <= 0 && variant.incoming) {
        $stock
          .html(
            theme.strings.willNotShipUntil.replace(
              '[date]',
              variant.next_incoming_date
            )
          )
          .removeClass('hide');
        return;
      }

      // If there's more than 10 available, hide stock
      $stock.addClass('hide');
    },

    _updateIncomingInfo: function(variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock);

      if (variant.incoming) {
        $stock
          .html(
            theme.strings.willBeInStockAfter.replace(
              '[date]',
              variant.next_incoming_date
            )
          )
          .removeClass('hide');
        return;
      }

      // If there is no stock incoming, hide stock
      $stock.addClass('hide');
    },

    _updateAddToCartBtn: function(evt) {
      var variant = evt.variant;
      var cache = {
        $addToCart: $(this.selectors.addToCart),
        $addToCartText: $(this.selectors.addToCartText),
         $addToCart02: $(this.selectors.addcartsho),
        $kyviyoBtn:$(this.selectors.klaviyoBtn)
      };


      if (variant) {
        // Select a valid variant if available
        $("#AddToCart").attr("disabled",false);
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
          cache.$addToCart.removeClass('btn--sold-out').prop('disabled', false);
          cache.$addToCartText.html(theme.strings.addToCart);
           cache.$addToCart02.removeClass('btn--sold-out');
          cache.$kyviyoBtn.addClass('hide');
          $(this.selectors.shopifyPaymentButton, this.$container).show();
          // Show how many items are left, if below 10
          this._updateStock(variant);
        } else {
          // Variant is sold out, disable the submit button
          cache.$addToCart.prop('disabled', true).addClass('btn--sold-out');
          cache.$addToCartText.html(theme.strings.soldOut);
          cache.$addToCart02.addClass('btn--sold-out');
          cache.$kyviyoBtn.removeClass('hide');
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
          // Update when stock will be available
          this._updateIncomingInfo(variant);
        }
      } else {
        cache.$addToCart.prop('disabled', true).removeClass('btn--sold-out');
        $("#AddToCart").attr("disabled",true);
        cache.$addToCartText.html(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
        // Hide stock display
        this._updateStock();
      }
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrice).html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );

        // Update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice)
            .html(
              theme.Currency.formatMoney(
                variant.compare_at_price,
                theme.moneyFormat
              )
            )
            .removeClass('hide');
          $(this.selectors.saleTag).removeClass('hide');
           $(this.selectors.changechajia).html(theme.Currency.formatMoney(
                variant.compare_at_price-variant.price,
                theme.moneyFormat
              )
              );
        } else {
          $(this.selectors.comparePrice).addClass('hide');
          $(this.selectors.saleTag).addClass('hide');
          
        }
      } else {
        $(this.selectors.comparePrice).addClass('hide');
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;
      if (variant) {
        $(this.selectors.SKU).html(variant.sku);
      }
    },
   _updateInventory: function(evt) {
      var variant = evt.variant;
      var variant_max_inv_qty = variant.inventory_quantity;
      // 不跟踪库存的情况下，以及跟踪库存但允许超额销售的情况下，开放无限库存（伪无限，9999）
      const isAllowInfinityShop = variant.inventory_management == null || (variant.inventory_management != null && variant.inventory_policy == 'continue');
      if (isAllowInfinityShop) {
        variant_max_inv_qty = 9999;
      }
      var current_qty_input = $(this.selectors.dataInventory).find(".js-qty__input");
      var c_qty_input_val;
      // 输入框允许的最大值
      $(this.selectors.dataInventory).attr("data-maxqty", variant_max_inv_qty > 1 ? variant_max_inv_qty : 1);
       c_qty_input_val = current_qty_input.val();
      if(c_qty_input_val > variant_max_inv_qty ){
        // 根据库存限制妥善改变输入框的值
        current_qty_input.val(variant_max_inv_qty > 1 ? variant_max_inv_qty : 1);
      }
      if (variant.inventory_quantity <= this.settings.stockSettingValue && variant.inventory_quantity > 0) {
        $(this.selectors.inventoryBox).removeClass('hide');
        $(this.selectors.inventory).html(variant.inventory_quantity);
      }
     else{
     	$(this.selectors.inventoryBox).addClass('hide');
     }
    },
    _updateImages: function(evt) {
      var variant = evt.variant;
      if (variant && variant.featured_media) {
        var imageId = variant.featured_media.id;
        this.switchProductImage(imageId);
        this.setActiveThumbnail(imageId);
      }
    },

    switchProductImage: function(imageId) {
//        var $imageToShow = $(
//          this.selectors.productImageContainers +
//            "[data-image-id='" +imageId +"']",
//          this.$container
//        );
//       var $imagesToHide = $(
//         this.selectors.productImageContainers +
//           ":not([data-image-id='" +
//           imageId +
//           "'])",
//         this.$container
//       );
//       $imagesToHide.addClass('hide');
//       $imageToShow.removeClass('hide');
      var index = $(`.media-image-item[data-image-id=${imageId}]`).data("slick-index");
      console.log("switchProductImage index : " + index);
      $('.photos-big').slick('slickGoTo', index);
    },

    setActiveThumbnail: function(imageId) {
//       var $thumbnailToShow = $(
//         this.selectors.productThumbContainers +
//           "[data-image-id='" +
//           imageId +
//           "']",
//         this.$container
//       );
//       var $thumbnailsToHide = $(
//         this.selectors.productThumbContainers +
//           ":not([data-image-id='" +
//           imageId +
//           "'])",
//         this.$container
//       );
//       $thumbnailsToHide.removeClass('is-active');
//       $thumbnailToShow.addClass('is-active');

//       var $thumbnails = $(this.selectors.productThumbsWrapper, this.$container);

//       // If there is a slick carousel, get the slide index, and position it into view with animation.
//       if ($thumbnails.hasClass('slick-initialized')) {
//         // eslint-disable-next-line shopify/jquery-dollar-sign-reference
//         var currentActiveSlideIndex = $thumbnails.slick('slickCurrentSlide');
//         var newActiveSlideIndex = parseInt(
//           $thumbnailToShow.attr('data-slick-index')
//         );
//         if (currentActiveSlideIndex !== newActiveSlideIndex) {
//           $thumbnails.slick('slickGoTo', newActiveSlideIndex, false);
//         }
//       }
    },

    _productZoomImage: function() {
      // The zoom image is only used on the product template, so return early
      // even if a featured product section is present.
      if (
        !$('.product-single ' + this.selectors.productImageContainers).length
      ) {
        return;
      }

      var self = this;

      $(this.selectors.productImageWrappers).on(
        'click' + this.settings.namespace,
        function(evt) {
          evt.preventDefault();
          // Empty src before loadig new image to avoid awkward image swap
          $(self.selectors.productZoomImage)
            .attr('src', '')
            .attr('src', $(this).attr('href'));
        }
      );

      this.ProductModal = new window.Modals(
        this.selectors.modal,
        'product-modal'
      );

      // Close modal if clicked, but not if the image is clicked
      this.ProductModal.$modal.on('click' + this.settings.namespace, function(
        evt
      ) {
        if (evt.target.nodeName !== 'IMG') {
          self.ProductModal.close();
        }
      });
    },

    _productThumbSwitch: function() {
      if (!$(this.selectors.productThumbs).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbs).on(
        'click' + this.settings.namespace,
        function(evt) {
          evt.preventDefault();
          var imageId = $(this)
            .parent()
            .data('image-id');
         // self.setActiveThumbnail(imageId);
          self.switchProductImage(imageId);
        }
      );
    },

    /*
      Thumbnail slider
     */
    _productThumbnailSlider: function() {
      var $productThumbsWrapper = $(this.selectors.productThumbsWrapper);
      var $productThumbs = $(this.selectors.productThumbs);
      if (!$productThumbs.length) {
        return;
      }

      if ($productThumbs.length > 1) {
//         $productThumbsWrapper.on(
//           'init' + this.settings.namespace,
//           this._productSwipeInit.bind(this)
//         );

        var nextArrow;
        var prevArrow;
        var sliderArrows = window.sliderArrows || false;

        // sliderArrows is an object defined in product.liquid to set custom
        // SVG arrow icons.
        if (sliderArrows) {
          nextArrow =
            '<button type="button" class="slick-next"><span class="medium-up--hide">' +
            sliderArrows.right +
            '</span><span class="small--hide">' +
            sliderArrows.right +
            '</span></button>';
          prevArrow =
            '<button type="button" class="slick-prev"><span class="medium-up--hide">' +
            sliderArrows.left +
            '</span><span class="small--hide">' +
            sliderArrows.left +
            '</span></button>';
        }


        
        $('.photos-big').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          fade: true,
          nextArrow: nextArrow,
          prevArrow: prevArrow,
          draggable:false,
          //asNavFor: $productThumbsWrapper
           responsive: [
            {
              breakpoint: this.settings.smallBreakpoint,
              settings: {
                fade: false,
              }
            }
          ]
        });
        
        $productThumbsWrapper.slick({
          accessibility: false,
          arrows: true,
          dots: false,
          infinite: false,
          autoplay: false,
          slidesToShow: 6,
          slidesToScroll: 6,
          vertical: false,
          verticalSwiping: false,
          nextArrow: nextArrow,
          prevArrow: prevArrow,
          //asNavFor: '.photos-big',
          //focusOnSelect: true,
          responsive: [
            {
              breakpoint: this.settings.smallBreakpoint,
              settings: {
                vertical: false,
                verticalSwiping: false,
                slidesToShow: 4,
                slidesToScroll: 4
              }
            }
          ]
        });
        
        $(this.selectors.productThumbContainers, this.$container).click(function() {
           $(this).addClass("is-active").siblings().removeClass('is-active'); 
		let index = $(this).data("slick-index");
            $('.photos-big').slick('slickGoTo', index);   
    });

   var galleryTimeout = null;
        $(this.selectors.productThumbContainers, this.$container).on({
            mouseenter: function () {
                var li = $(this);
              //  li.addClass("is-active").siblings().removeClass('is-active'); 
                clearTimeout(galleryTimeout);
                if (!li.hasClass('is-active')) {
                    galleryTimeout = setTimeout(function () { 
                      li.click();
                     // let index = $(this).data("slick-index");
                    //  console.log(index);  
                    }, 200);
                }
            },
            mouseleave: function () {
                clearTimeout(galleryTimeout);

            }
           });
        
//          $('.photos-big').on('afterChange', function(event, slick, currentSlide, nextSlide) {
// 			var i = currentSlide ;
//            $(`.product-single__thumbnail-item[data-slick-index=${i}]`).addClass("is-active").siblings().removeClass('is-active');
// });
        

        // Show highlighted thumbnail by repositioning slider
//         $productThumbsWrapper.slick(
//           'slickGoTo',
//           $productThumbsWrapper.find('.is-active').attr('data-slick-index'),
//           true
//         );
      }
    },

    _productSwipeInit: function(evt, obj) {
      // Slider is initialized. Setup custom swipe events
      this.settings.productThumbIndex = obj.currentSlide;
      this.settings.productThumbMax = obj.slideCount - 1; // we need the 0-based index

      var self = this;

      $(this.selectors.productImageWrappers).on(
        'swipeleft swiperight',
        function(event) {
          if (event.type === 'swipeleft') {
            self._goToNextThumbnail();
          }

          if (event.type === 'swiperight') {
            self._goToPrevThumbnail();
          }

          // Trigger click on newly requested thumbnail
          $(
            '.product-single__thumbnail-item[data-slick-index="' +
              self.settings.productThumbIndex +
              '"]'
          )
            .find('.product-single__thumbnail')
            .trigger('click');
        }
      );
    },

    _goToNextThumbnail: function() {
      this.settings.productThumbIndex++;

      if (this.settings.productThumbIndex > this.settings.productThumbMax) {
        this.settings.productThumbIndex = 0;
      }

      $(this.selectors.productThumbsWrapper).slick(
        'slickGoTo',
        this.settings.productThumbIndex,
        true
      );
    },

    _goToPrevThumbnail: function() {
      this.settings.productThumbIndex--;

      if (this.settings.productThumbIndex < 0) {
        this.settings.productThumbIndex = this.settings.productThumbMax;
      }

      $(this.selectors.productThumbsWrapper).slick(
        'slickGoTo',
        this.settings.productThumbIndex,
        true
      );
    },

    _initQtySelector: function() {
      this.$container.find('.product-form__quantity').each(function(i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    onUnload: function() {
      $(this.selectors.productImageWrappers).off(this.settings.namespace);
      $(this.selectors.productThumbs).off(this.settings.namespace);
      $(this.selectors.productThumbs).slick('unslick');
      if (this.ProductModal) {
        this.ProductModal.$modal.off(this.settings.namespace);
      }
    }
  });

  return Product;
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };
  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: true,
      dots: false,
      fade: false,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    );

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

theme.Cart = (function() {
  var selectors = {
    cartNote: '#CartSpecialInstructions',
    cartQtyInput: '.cart__quantity',
    cartNoCookiesClass: 'cart--no-cookies'
  };

  function Cart(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    theme.cartObject = JSON.parse($('#CartJson-' + sectionId).html());

    this.init($container);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    init: function($container) {
      this._initQtySelector();
      this._initCartNote();

      if (!this._cookiesEnabled()) {
        $container.addClass(selectors.cartNoCookiesClass);
      }
    },

    _initQtySelector: function() {
      $(selectors.cartQtyInput).each(function(i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    _initCartNote: function() {
      if (!$(selectors.cartNote).length) {
        return;
      }

      var $el = $(selectors.cartNote);
      var noteText;
      var params;
      var noteOffset = $el[0].offsetHeight - $el[0].clientHeight;

      // Auto grow the cart note if text fills it up
      $el.on('keyup input', function() {
        $(this)
          .css('height', 'auto')
          .css('height', $el[0].scrollHeight + noteOffset);
      });

      // Save the cart note via ajax. A safeguard in case
      // a user decides to leave the page before clicking 'Update Cart'
      $el.on(
        'change',
        $.proxy(function() {
          noteText = $el.val();
          params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + this._attributeToString(noteText),
            dataType: 'json'
          };
          $.ajax(params);
        }, this)
      );
    },

    _attributeToString: function(attr) {
      if (typeof attr !== 'string') {
        attr = String(attr);
        if (attr === 'undefined') {
          attr = '';
        }
      }
      return $.trim(attr);
    },

    _cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

theme.Quotes = (function() {
  function Quotes(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));

    this.$container.slick({
      accessibility: true,
      arrows: true,
      dots: false,
      draggable: true,
      autoplay: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              adaptiveHeight: true
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: true
            }
          }
        ]
    });
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },

    _goToSlide: function(slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function() {
      delete this.$container;
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.quote__slide-wrapper--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      this._goToSlide(slideIndex);
    }
  });

  return Quotes;
})();

theme.Video = (function() {
  var promiseYoutubeAPI;
  var promiseVimeoAPI;

  var youtube = {
    promiseAPI: function() {
      if (!promiseYoutubeAPI) {
        var tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        promiseYoutubeAPI = $.Deferred(function(defer) {
          window.onYouTubeIframeAPIReady = defer.resolve;

          setTimeout(function() {
            defer.reject('Request for YouTube API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseYoutubeAPI;
    },
    promisePlayer: function(id, options) {
      return this.promiseAPI().then(function() {
        return $.Deferred(function(defer) {
          if (typeof window.YT === 'undefined') {
            defer.reject(
              "We're sorry, something went wrong. The YouTube API has not loaded correctly."
            );
          }

          /* eslint-disable no-undef */
          var player = new YT.Player(id, options); // global YT variable injected by YouTube API

          player.addEventListener('onReady', function() {
            defer.resolve(player);
          });

          setTimeout(function() {
            defer.reject(
              'Request for YouTube player has timed out after 30 seconds.'
            );
          }, 30000);
        });
      });
    }
  };

  var vimeo = {
    promiseAPI: function() {
      if (!promiseVimeoAPI) {
        promiseVimeoAPI = $.Deferred(function(defer) {
          var tag = document.createElement('script');
          tag.src = 'https://player.vimeo.com/api/player.js';
          tag.onload = tag.onreadystatechange = function() {
            if (!this.readyState || this.readyState === 'complete') {
              defer.resolve();
            }
          };

          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          setTimeout(function() {
            defer.reject('Request for Vimeo API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseVimeoAPI;
    },

    promisePlayer: function(id, options) {
      return this.promiseAPI().then(function() {
        return $.Deferred(function(defer) {
          if (typeof window.Vimeo === 'undefined') {
            defer.reject(
              "We're sorry, something went wrong. The Vimeo API has not loaded correctly."
            );
          }

          var player = new window.Vimeo.Player(id, options);

          setTimeout(function() {
            defer.reject(
              'Request for Vimeo player has timed out after 30 seconds.'
            );
          }, 30000);

          player.ready().then(function() {
            defer.resolve(player);
          });
        });
      });
    }
  };

  var selectors = {
    loadPlayerButton: '.video-section__load-player-button',
    closePlayerButton: '.video-section__player-close',
    playerContainer: '.video-section__player',
    cover: '.video-section__cover',
    errorMessage: '.video-section__error',
    bodyOverlay: '.video-section__body-overlay',
    body: 'body'
  };
  var classes = {
    playerLoading: 'video-section--loading',
    playerLoaded: 'video-section--loaded',
    playerError: 'video-section--error',
    videoPlaying: 'video-playing'
  };

  function Video(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');
    this.namespace = '.' + sectionId;
    this.onLoad();
  }

  Video.prototype = _.assignIn({}, Video.prototype, {
    onLoad: function() {
      this.$container
        .on('click', selectors.loadPlayerButton, this._loadPlayer.bind(this))
        .on('click', selectors.closePlayerButton, this._closePlayer.bind(this))
        .on('click', selectors.bodyOverlay, this._closePlayer.bind(this));
    },

    _loadPlayer: function() {
      var $container = this.$container;
      var $playerContainer = $(selectors.playerContainer, $container);
      var playerType = this.$container.attr('data-video-type');

      var promiseVideoPlayer;

      if (playerType === 'youtube') {
        promiseVideoPlayer = this._loadYoutubePlayer($playerContainer[0]);
      } else if (playerType === 'vimeo') {
        promiseVideoPlayer = this._loadVimeoPlayer($playerContainer[0]);
      }

      return promiseVideoPlayer
        .then(this._onPlayerLoadReady.bind(this))
        .fail(this._onPlayerLoadError.bind(this));
    },

    _loadYoutubePlayer: function(container) {
      return youtube
        .promisePlayer(container, {
          videoId: this.$container.attr('data-video-id'),
          ratio: 16 / 9,
          playerVars: {
            modestbranding: 1,
            autoplay: 1,
            showinfo: 0,
            rel: 0
          }
        })
        .then(
          function(player) {
            this.player = player;
          }.bind(this)
        );
    },

    _loadVimeoPlayer: function(container) {
      return vimeo
        .promisePlayer(container, {
          id: this.$container.attr('data-video-id')
        })
        .then(
          function(player) {
            this.player = player;
            this.player.play();
          }.bind(this)
        );
    },

    _onPlayerLoadReady: function() {
      $(selectors.closePlayerButton, this.$container)
        .show()
        .focus();
      $(selectors.cover, this.$container).addClass(classes.playerLoaded);
      this.$container.addClass(classes.playerLoaded);

      this._setScrollPositionValues();

      $(selectors.body).addClass(classes.videoPlaying);

      $(document).on('keyup' + this.namespace, this._closeOnEscape.bind(this));
      $(window).on(
        'resize' + this.namespace,
        this._setScrollPositionValues.bind(this)
      );
      slate.a11y.trapFocus({
        $container: this.$container,
        namespace: this.namespace
      });
    },

    _onPlayerLoadError: function(err) {
      this.$container.addClass(classes.playerError);
      $(selectors.errorMessage, this.$container).text(err);
    },

    _closeOnEscape: function(evt) {
      if (evt.keyCode !== 27) {
        return;
      }

      this._closePlayer();
      $(selectors.loadPlayerButton, this.$container).focus();
    },

    _onScroll: function() {
      var scrollTop = $(window).scrollTop();

      if (
        scrollTop > this.videoTop + 0.25 * this.videoHeight ||
        scrollTop + this.windowHeight <
          this.videoBottom - 0.25 * this.videoHeight
      ) {
        // Debounce DOM edits to the next frame with requestAnimationFrame
        requestAnimationFrame(this._closePlayer.bind(this));
      }
    },

    _setScrollPositionValues: function() {
      this.videoHeight = this.$container.outerHeight(true);
      this.videoTop = this.$container.offset().top;
      this.videoBottom = this.videoTop + this.videoHeight;
      this.windowHeight = $(window).innerHeight();
    },

    _closePlayer: function() {
      $(selectors.body).removeClass(classes.videoPlaying);
      $(selectors.cover, this.$container).removeClass(classes.playerLoaded);
      this.$container.removeClass(classes.playerLoaded);
      $(selectors.closePlayerButton, this.$container).hide();

      slate.a11y.removeTrapFocus({
        $container: this.$container,
        namespace: this.namespace
      });

      if (typeof this.player.destroy === 'function') {
        this.player.destroy();
      } else if (typeof this.player.unload === 'function') {
        this.player.unload();
      }

      $(document).off(this.namespace);
      $(window).off(this.namespace);
    }
  });

  return Video;
})();

theme.CollectionsList = (function() {
  function CollectionsList(container) {
    var $container = (this.$container = $(container));
    var stretchImage = $container.is('[data-stretch-image]');

    // Early return if 'secondary image layout' is enabled
    if (stretchImage) return;

    var namespace = (this.namespace = '.' + $container.attr('data-section-id'));
    var self = this;

    self._collectionListFix();
    $(window).on(
      'resize' + namespace,
      $.debounce(250, function() {
        self._collectionListFix();
      })
    );
  }

  CollectionsList.prototype = _.assignIn({}, CollectionsList.prototype, {
    onUnload: function() {
      $(window).off(this.namespace);
    },

    _collectionListFix: function() {
      var numberRows = this.$container.find('.grid').data('number-rows');
      var $featureCards = this.$container.find('.featured-card');

      // We can exit if 'Use secondary image layout' is enabled
      if ($featureCards.is('[data-stretch-image]')) return;

      // Go through each of the rows
      for (var i = 0; i < numberRows; i++) {
        var maxWrapperHeight = 0;
        var maxHeaderHeight = 0;
        var $currentRow = $featureCards.filter(
          "[data-row-number='" + (i + 1) + "']"
        );
        var $cardHeaders = $currentRow.find('.featured-card__header');

        // Find the max heights for each row
        $currentRow.each(function() {
          var $cardTitle = $(this).find('.featured-card__title');
          var $cardAction = $(this).find('.featured-card__action');
          var $cardImageWrapper = $(this).find('.featured-card__image-wrapper');
          var headerHeight =
            $cardTitle.outerHeight() + $cardAction.outerHeight() + 65;
          var wrapperHeight = $cardImageWrapper.outerHeight();
          if (headerHeight > maxHeaderHeight) {
            maxHeaderHeight = headerHeight;
          }
          if (wrapperHeight > maxWrapperHeight) {
            maxWrapperHeight = wrapperHeight;
          }
        });

        // Set the heights of the headers and cards for this row with padding
        $cardHeaders.outerHeight(maxHeaderHeight);
        $currentRow.height(maxWrapperHeight + maxHeaderHeight + 40);
      }
    }
  });

  return CollectionsList;
})();


theme.init = function() {
  theme.customerTemplates.init();
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  // Sections
  var sections = new theme.Sections();
  sections.register('header', theme.HeaderSection);
  sections.register('product', theme.Product);
  sections.register('collection-filters', theme.Filters);
  sections.register('map', theme.Maps);
  sections.register('slideshow', theme.Slideshow);
  sections.register('cart', theme.Cart);
  sections.register('quotes', theme.Quotes);
  sections.register('video', theme.Video);
  sections.register('collections-list', theme.CollectionsList);

  // Standalone modules
  $(window).on('load', theme.articleImages);
  theme.passwordModalInit();
};

theme.articleImages = function() {
  var $indentedRteImages = $('.rte--indented-images');
  if (!$indentedRteImages.length) {
    return;
  }

  $indentedRteImages.find('img').each(function(i, el) {
    var $el = $(el);
    var attr = $el.attr('style');

    // Check if undefined or float: none
    if (!attr || attr === 'float: none;') {
      // Add class to parent paragraph tag if image is wider than container
      if ($el.width() >= $indentedRteImages.width()) {
        $el.parent('p').addClass('rte__image-indent');
      }
    }
  });
};

theme.passwordModalInit = function() {
  var $loginModal = $('#LoginModal');
  if (!$loginModal.length) {
    return;
  }

  // Initialize modal
  theme.PasswordModal = new window.Modals('LoginModal', 'login-modal', {
    focusOnOpen: '#Password'
  });

  // Open modal if errors exist
  if ($loginModal.find('.errors').length) {
    theme.PasswordModal.open();
  }
};

$(theme.init);

// link turns
$(function(){
  var url = String(window.location);
  var suburl = url.split("com")[1];
  $(".site-contact__list>li>a").each(function(){
    if($(this).attr('href') ==suburl ){
      $(this).addClass("addblackcolor");
      //     $(this).parent().siblings().child().removeClass("addblackcolor");
    }
  });
     
  
  //      to mousedown header normal  when mouseup header fixed
 var scrollFunc=function(event){ 
 
    e=event || window.event;     
    if(e.wheelDelta){//IE/Opera/Chrome 
    	if(e.wheelDelta>0) 
		{
	 //向上滚动事件<br> 
		$(".comment_block_collection").css("opacity","1");
			
		}else
		{ 
			//向下滚动事件
		$(".comment_block_collection").css("opacity","0");

		} 
    }else if(e.detail){
    	//Firefox 
    	if(e.detail < 0) { 
    		//向上滚动事件<br> 
		$(".comment_block_collection").css("opacity","1");
    		
    	}else { 
			//向下滚动事件<br>
		$(".comment_block_collection").css("opacity","0");
    		
		} 
    } 
 };
 if(document.addEventListener){ 
	//adding the event listerner for Mozilla
	 document.addEventListener("DOMMouseScroll" ,scrollFunc, false);
	 }
	 //IE/Opera/Chrome 
	 window.onmousewheel=document.onmousewheel=scrollFunc;
});




// Fold js 
$(function() {
  $(".brand-title").click(function () {
    var $div = $(this).siblings(".brand-box");
    if ($(this).parent().hasClass("list-selected")) {
      $div.slideUp(600);
      $(this).parent().removeClass("list-selected");
    }
    if ($div.is(":hidden")) {
      $(".accreditions-block .brand-type").find(".brand-box").slideUp(600);
      $(".accreditions-block .brand-type").removeClass("list-selected");
      $(this).parent().addClass("list-selected");
      $div.slideDown(600);
    } else {
      $div.slideUp(600);
    }
  });
});


$(function() {
  $(".close-slidebar>span").click(function(){
    $(".filters-toolbar").addClass("movetagfilter").removeClass("movetagfilter02");
    $(".over-nav-tag").hide();
    $("#smile-ui-container").css("opacity", "1");
  })
  $(".over-nav-tag").click(function(){
    $(".filters-toolbar").addClass("movetagfilter").removeClass("movetagfilter02");
    $(this).hide();
    $("#smile-ui-container").css("opacity", "1");
  })
  $(".collection-sort__label001").click(function(){
    $(".filters-toolbar").addClass("movetagfilter02").removeClass("movetagfilter");
    $(".over-nav-tag").show();
    $("#smile-ui-container").css("opacity", "0");
  })
    

    $('.site-header__cart').click(function(e){
      ajaxCart.load();
      $('body').toggleClass("iscartpopup"); 
      e.preventDefault();
    });
  $('.close-cart').click(function(e){
    $('body').toggleClass("iscartpopup"); 
  });
   $('.wrapoverblack').click(function(e){
    $('body').toggleClass("iscartpopup"); 
  });
  
  $("body").bind("click",function(evt){ 
    if($(evt.target).closest("#CartDrawer").length==0&&$(evt.target).closest(".site-header__cart").length==0)
    { 
//       $('body').removeClass("iscartpopup"); 
    } 
  });   
//   faq    
  $('.faq-slider .question').click(function() {
    if($(this).next('.answer').is(':hidden')){
      $(this).addClass("isopen");
    }
    else{
      $(this).removeClass("isopen");
    }

    $(this).next('.answer').slideToggle(); 

  });  
  $("body").bind("click",function(evt){ 
    if($(evt.target).closest(".footer-currencys").length==0)
    { 

      $(".geolizr-currency-list.geolizr-currency-links").css("display",'none');
    } 
  }); 
  $(".product-form__cart-submit-index,#AddToCart").click(function(){

    try{
      __adroll.record_user({"adroll_segments": "shopify_added_product_to_cart"})   
    } catch(err) {}

  });
  $("#support>a").attr("disabled",true).css("pointer-events","none"); 

});
$(".product-single__photo-video iframe").height($(".photos__item--main").width()*9/16);
$(".view-choose-btns li").click(function(){
  $(this).addClass("active").siblings().removeClass("active");
});
$(".product-images-btn").click(function(){
  if( !$(".modle-views-container").is(":hidden")){
//	$(this).find(".ss-deletes").hide();
   	$(".page-container").css("z-index","20");
  	$(".modle-views-container").fadeOut();
  };
  if(!$(".video-box-container").is(":hidden")){
  //  $(this).find(".ss-deletes").hide();
   $(".page-container").css("z-index","20");
  	$(".video-box-container").fadeOut();
  }
  $(".photos-big").css("opacity","1");
 $(".photos__item--thumbs").removeClass("coverbg");
  
});
$(".product-videos-btn").click(function(){
  if( !$(".modle-views-container").is(":hidden")){
//	$(".ss-deletes").hide();
   	$(".page-container").css("z-index","20");
  	$(".modle-views-container").fadeOut();
  }   
  if($(".video-box-container").is(":hidden")){
  //  $(this).find(".ss-deletes").show();
    $(".page-container").css("z-index","21");
  }else{
  //  $(this).find(".ss-deletes").hide();
      $(".page-container").css("z-index","20");
  }
  $(".video-box-container").fadeToggle();
 $(".photos-big").css("opacity","0");
  $(".photos__item--thumbs").addClass("coverbg");
});

$(".product-3dview-btn").click(function(){
    if(!$(".video-box-container").is(":hidden")){
 //   $(this).find(".ss-deletes").hide();
   $(".page-container").css("z-index","20");
  	$(".video-box-container").fadeOut();
  };
  if($(".modle-views-container").is(":hidden")){
 //   $(this).find(".ss-deletes").show();
    $(".page-container").css("z-index","21");
  }else{
 //   $(this).find(".ss-deletes").hide();
      $(".page-container").css("z-index","20");
  }
  $(".modle-views-container").fadeToggle();
  $(".photos-big").css("opacity","0");
 $(".photos__item--thumbs").addClass("coverbg");
});


$(".fancybox-container-box").on("click",".fancybox-video-btn",function(){
 $(this).addClass("active").siblings().removeClass("active");
	 $(".fancybox-thumbs").hide();
  $(".fancybox-stage").hide();
  $(".fancybox-navigation").hide();
  $(".fancybox-3d-box").hide();
  $(".fancybox-button--zoom").hide();
  $(".fancybox-button--play").hide();
  $(".fancybox-infobar").hide(); 
  $(".fancybox-3d-preview-box").hide();
  $(".fancybox-video-box").show();
  $(".fancybox-video-preview-box").show();
  
});
$(".fancybox-container-box").on("click",".fancybox-3d-btn",function(){
   $(this).addClass("active").siblings().removeClass("active");
	 $(".fancybox-thumbs").hide();
  $(".fancybox-stage").hide();
  $(".fancybox-video-box").hide();
   $(".fancybox-navigation").hide();
  $(".fancybox-button--zoom").hide();
  $(".fancybox-button--play").hide(); 
  $(".fancybox-infobar").hide();
   $(".fancybox-video-preview-box").hide();
  $(".fancybox-3d-box").show();
  $(".fancybox-3d-preview-box").show();
  
});
$(".fancybox-container-box").on("click",".fancybox-product-img-btn",function(){
   $(this).addClass("active").siblings().removeClass("active");
  $(".fancybox-video-box").hide();
  $(".fancybox-3d-box").hide();
   $(".fancybox-video-preview-box").hide();
  $(".fancybox-3d-preview-box").hide();
	 $(".fancybox-thumbs").show();
  $(".fancybox-stage").show();
   $(".fancybox-navigation").show();
   $(".fancybox-button--zoom").show();
  $(".fancybox-button--play").show(); 
  $(".fancybox-infobar").show();
  
});



// $(document).ready(function(){
//       setTimeout(()=>{
//       document.getElementById('christmas_footer_img').style.zIndex='-2';
//     },14000);         
   
//        setTimeout(()=>{
//       document.getElementById('christmas_footer_img').style.zIndex='0';
//     },15500);         
//     })
//  	setInterval(() => { 
//      setTimeout(()=>{
//       document.getElementById('christmas_footer_img').style.zIndex='-2';
//     },14000);
//      document.getElementById('christmas_footer_img').style.zIndex='0';
//     },16000);


 // countdown
var InterValObj,SysSecond;

SysSecond=$('#countdown_box').data('countdown')||'';


  var bf_time_end = new Date(SysSecond); 
  bf_time_end = bf_time_end.getTime();

InterValObj = setInterval(function(){SetRemainTime()}, 1000);
  function SetRemainTime(){ 
    var bf_time_now = new Date();  
    bf_time_now = bf_time_now.getTime();
    var bf_time_distance = bf_time_end - bf_time_now;  
    var bf_int_day, bf_int_hour, bf_int_minute, bf_int_second; 
    if(bf_time_distance <= 0){
       $('#countdown_box .day').html('00');
    $('#countdown_box .hour').html('00'); 
    $('#countdown_box .minite').html('00');
    $('#countdown_box .second').html('00');
     clearInterval(InterValObj);
     return;
    }
    bf_int_day = Math.floor(bf_time_distance/86400000)
    bf_time_distance -= bf_int_day * 86400000; 
     
    bf_int_hour = Math.floor(bf_time_distance/3600000) 
    bf_time_distance -= bf_int_hour * 3600000;  

    bf_int_minute = Math.floor(bf_time_distance/60000)    
    bf_time_distance -= bf_int_minute * 60000; 

    bf_int_second = Math.floor(bf_time_distance/1000)    
    if(bf_int_day < 10) 
      bf_int_day = "0" + bf_int_day;  
    if(bf_int_hour < 10) 
      bf_int_hour = "0" + bf_int_hour;    

    if(bf_int_minute < 10)    
      bf_int_minute = "0" + bf_int_minute;  

    if(bf_int_second < 10) 
      bf_int_second = "0" + bf_int_second;        
    $('#countdown_box .day').html(bf_int_day);
    $('#countdown_box .hour').html(bf_int_hour); 
    $('#countdown_box .minite').html(bf_int_minute); 
    $('#countdown_box .second').html(bf_int_second);
  }


 function initScrollTop () {
   let win =$(window);
          $('#smile-ui-container').addClass('hide');
            var backToTop = $('#back-top');
   
            var p=0,
                t=0;
            win.scroll(function(){
              
              p=$(this).scrollTop();
              
              if (p > 220) {
                backToTop.fadeIn(400);
              } else {
                backToTop.fadeOut(400);
              }
              if(p==0){
                $('#smile-ui-container').css('display','block');
                $('#gorgias-chat-container').removeClass('hide');
                $('#back-top').removeClass('hide');                
              }
              if(t<p){//down
                $('#smile-ui-container').css('display','none');
                $('#gorgias-chat-container').addClass('hide'); 
                $('#back-top').addClass('hide');
              }else{//up          
                $('#smile-ui-container').css('display','block');
                $('#gorgias-chat-container').removeClass('hide');
                $('#back-top').removeClass('hide'); 
              }
              setTimeout(function(){ t = p ; },5000)
            })


            backToTop.off('click.scrollTop').on('click.scrollTop', function (e) {
                e.preventDefault();
                e.stopPropagation();

                $('html, body').animate({
                    scrollTop: 0
                }, 400);
                return false;
            });
        }
 initScrollTop();



$('.faq-tab li').click(function(){
  	let parIndex=$(this).index();
  parIndex=parIndex+1;
  console.log(parIndex);
    $(this).addClass('active').siblings().removeClass('active');
  $(`.shopify-section-item:eq(${parIndex-1})`).addClass('active').siblings().removeClass('active');
  $(`.qbi-outer-box-${parIndex} .qbim-item:eq(0),.qbi-outer-box-${parIndex} .qbim-content-box:eq(0),.qbi-outer-box-${parIndex} .qbim-content-box .cebian-slide-title:eq(0)`).addClass('active').siblings().removeClass('active');
    offsetList=[];
    initOffset();
  })

$('.qbim-item').click(function(){
	let parIndex=$(this).data('parindex'),index=$(this).data('index');
    $(this).addClass('active').siblings().removeClass('active');
    $(`.qbim-content-box-${parIndex}-${index}`).addClass('active').siblings().removeClass('active');
   $('.qbim-content-box.active  .cebian-slide-title:eq(0)').addClass('active').siblings().removeClass('active');
    offsetList=[];
    initOffset();
})


let pageTemplate=""; let offsetList=[];

$(document).ready(function(){
 initOffset();
})
$(window).resize(function(){
  offsetList=[];
 initOffset();
})
function initOffset(){
 $('.qbim-content-box.active .qbi-box').each(function(){ 
   let index=$(this).data('index');
   let name=`qbi-box-${index}`;
   let slide_name=`cebian-slide-title-${index}`;
    let offset=$(this).offset().top;
   offsetList.push(
     {
       name:name,
       slide_name:slide_name,
       offset:offset
     }
   ) 
  })  
}
if ($('.qa-bank-container').data('template') == "qa-bank-container") {

    $(window).scroll(function (e) {
        var scrollTop = $(document).scrollTop();
        var scrollTopPlus = scrollTop +150;
        let qbimcbHeight = $('.qbim-content-box.active .qbimcb-content').height();
        let thisHeight = $('.qbim-content-box.active .cebian-slide').height();

        let parPositionTop = $('.qbim-content-box.active .qbimcb-content').offset().top;
        let parPositionLeft = $('.qbim-content-box.active .qbimcb-content').offset().left;
       
        if (scrollTop > parPositionTop && scrollTop < (parPositionTop + qbimcbHeight - thisHeight)) {
            $('.qbim-content-box.active .cebian-slide').addClass('sticky').css('left', `${parPositionLeft}px`);
        }
        else {
            $('.qbim-content-box.active .cebian-slide').removeClass('sticky').css('left', `0px`);
        }
 
     
      offsetList.forEach((v, k) => {
            if (scrollTopPlus > v.offset) {
                $(`.qbim-content-box.active .${v.slide_name}`).addClass('active').siblings().removeClass('active');
            }
        })
     
      
        
    })
}


$('.cebian-slide-title').click(function(){
	let parEl=$(this).parents('.qbim-content-box.active');
  let index=$(this).data('index');
   $(this).addClass('active').siblings().removeClass('active');
  	$("html,body").animate({
  scrollTop:parEl.find(`.qbi-box-${index}`).offset().top -50+ "px"
  }, 0);
  return false;
})


 

 
  $(document).ready(function(){
   let nowUrl=window.location.href;
    if($('.faq-tab li').length!=0){
      if(nowUrl.indexOf('#')!=-1){
       let type=nowUrl.split('#')[1].toLowerCase();
     $('.faq-tab li').each(function(){
     let name=$(this).data('name');
      if(type==name){
       $(this).click();
      }
    })
      }
   
    }
   
  })
  

  
  
  

function DateDiff(obj) {
  let status=$(obj).data('status');
    let pint=parseInt($(obj).data('pint'));
    let custom=parseInt($(obj).data('custom'));
    let start=$('.qa-bank-share-btn-box').data('time');
    let myDate = new Date;
    let year = myDate.getFullYear(); //获取当前年
    let mon = myDate.getMonth() + 1; //获取当前月
    let date = myDate.getDate(); //获取当前日
  
  
    let sdate = new Date(start);
    let now =`${year}-${mon}-${date}`;
    let ndate = new Date(now);
    let days = ndate.getTime() - sdate.getTime()+1;
    let day = parseInt(days / (1000 * 60 * 60 * 24));
  let count="";
  if(status=="one"){
    count=custom+Math.ceil(custom*(day*((pint*0.01))));
  }
  else{
    count=Math.ceil((day*((pint*0.01))));
    }
    
    $(obj).find(".automatic_count").text(count);
    return day; 

}

$('.qa-bank-share-btn-box .cell').each(function () {
    let that = this;
    DateDiff(that);
})

$('.qa-bank-share-btn-box .cell').click(function () {
    let count = parseInt($(this).find('.count').text());
    $(this).find('.count').text(count + 1);
})




$(window).scroll(function () {
  $("body .js-scroll-fade-in").each(function(){
    let that=this;
        if (($(window).scrollTop() + $(window).height()) > $(that).offset().top) {
           $(that).addClass('is_over');
        }
        else {
           $(that).removeClass('is_over');
        }
      })  
    });





// $(document).ready(function(){
//   $('.qr20-text-container .item').each(function(){
//      let  x = 20;
//      let z=80;
//      let y = 0;
   
//      let top=parseInt(Math.random() * (z - y + 1) + y);
//      let left=parseInt(Math.random() * (x - y + 1) + y);
//     $(this).css({'top':`${top}%`,'left':`${left}%`});
//   })
// })




$(function () { // wait for document ready
    // build scene
    // init controller
    var controller = new ScrollMagic.Controller();
    var t = new TimelineMax();
    t.add(TweenLite.to("#product-image", 10, { css: { scale:1, opacity: 1 }, ease:Linear.ease }))
     .add(TweenLite.fromTo(".qr20-text-container .one", 10, { x: "100%"}, { css: { x: "0%" }, ease:Linear.ease }))
     .add(TweenLite.to(".qr20-text-container .one", 10,  { css: { opacity:0.5, scale:0.9 }, ease: Linear.ease }))
     .add(TweenLite.fromTo(".qr20-text-container .two", 10, { x: "100%" }, { css: { x: "0%" }, ease: Linear.ease}))
     .add(TweenLite.to(".qr20-text-container .two", 10,  { css: {  scale:1 }, ease:Linear.ease }))
     .add(TweenLite.fromTo(".logo-contianer", 10, { x: "100%" }, { css: { x: "0%" }, ease: Linear.ease }))
     .add(TweenLite.fromTo(".logo-contianer .second-logo", 40, { x: "0%" } ,{ css: { x: "-72%" }, ease: Linear.ease }))
     .add(TweenLite.to("#product-image", 40, { css: { scale:1 }, ease: Linear.ease }))
     .add(TweenLite.to("#product-image", 10, { css: { scale:0.8, y:'-100px' }, ease: Linear.ease }))
     .add(TweenLite.to(".qr20-first-item .one-item", 30, { css: {opacity:0 }, ease: Linear.ease }))
     .add(TweenLite.to(".qr20-first-item .second-item", 10, { css: {opacity:1 }, ease: Linear.ease }))
     .add(TweenLite.to("#si-title", 10, { css: {y:"-60px",opacity:1 }, ease: Linear.easeOut }))
     .add(TweenLite.to(".si-bottom-content", 10, { css: {y:"-60px",opacity:1 }, ease: Linear.easeOut }))
    // build scene
    if($(window).width()>1921){
     var scene = new ScrollMagic.Scene({ triggerElement: "#ct-1", duration: 3000, offset: 540 })
        .setTween(t)
        .setPin("#ct-1")
        .addTo(controller);
    }else{
     var scene = new ScrollMagic.Scene({ triggerElement: "#ct-1", duration: 3000, offset: 460 })
        .setTween(t)
        .setPin("#ct-1")
        .addTo(controller);
    }
if($("body").hasClass("template-GD-88")){
		var wipeAnimationswap = new TimelineMax()
			// animate to second panel
			// .to("#slideContainerswap", 0.1, {z: 0})		// move back in 3D space
  
  var GD88swapcontroller = new ScrollMagic.Controller();

		// define movement of panels
			// .to("#slideContainerswap", 0.1,   {x: "-50%"})	// move in to first panel
			// .to("#slideContainerswap", 0.1, {z: 0})				// move back to origin in 3D space
  wipeAnimationswap.add([
                         TweenMax.to("#slideContainerswap>section:nth-child(1)", 1, {className:"+=trunonleft1",delay: 1}),
                         TweenMax.to("#GD-88-swap-Container > div.progress-swap-container.page-width > p > span:nth-child(1)", 1, {className:"+=span_hide",delay: 1}),
                         TweenMax.to("#GD-88-swap-Container > div.progress-swap-container.page-width > p > span:nth-child(2)", 1, {className:"+=span_show",delay: 1}),
                         TweenMax.to("#slideContainerswap>section:nth-child(2)", 1, {className:"+=trunonleft2",delay: 1})
                        ])
           
           //animate to third panel
			// .to("#slideContainerswap", 0.5, {z: 0, delay: 1})
			// .to("#slideContainerswap", 3,   {x: "-50%"})
			// .to("#slideContainerswap", 0.5, {z: 0})
			//  animate to forth panel
			// .to("#slideContainerswap", 0.5, {z: 0, delay: 1})
			// .to("#slideContainerswap", 3,   {x: "-75%"})
			// .to("#slideContainerswap", 0.5, {z: 0});

		// create scene to pin and link animation
     if($(window).width()>1000){
		new ScrollMagic.Scene({
				triggerElement: "#GD-88-swap-Container",
				triggerHook: "onLeave",
				duration: "100%"
			})
			.setPin("#GD-88-swap-Container")
			.setTween(wipeAnimationswap)
			.addTo(GD88swapcontroller);
       
     }
   
        // $(window).on("scroll",function(){
        // console.log($(window).scrollTop())

        //   if ($(window).scrollTop() >6911) {
        //     if (parseInt($(".progress_swap span").text())<$(".panel").length) {
        //     var swap_page_num='0'+(parseInt($(".progress_swap span").text())+1)
        //     $(".progress_swap span").text(swap_page_num)
        //     }
        //   }else{
        //     if (parseInt($(".progress_swap span").text())>1) {
        //     var swap_page_num='0'+(parseInt($(".progress_swap span").text())-1)
        //     $(".progress_swap span").text(swap_page_num)
        //     }
        //   }
        // })
   // if ($("#slideContainerswap > section:nth-child(1)").hasClass("trunonleft1")) {
   //            var swap_page_num='0'+(parseInt($(".progress_swap span").text())+1)
   //                            $(".progress_swap span").text(swap_page_num)
   //          } else {
   //              if (parseInt($(".progress_swap span").text())>1) {
   //                            var swap_page_num='0'+(parseInt($(".progress_swap span").text())-1)
   //                            $(".progress_swap span").text(swap_page_num)
   //                          }
   //          }

   
                        // init Card
							var controllerCard = new ScrollMagic.Controller();
	
							// define movement of panels
							var wipeCardAnimation = new TimelineMax();								
        						
 wipeCardAnimation.add(TweenLite.to(".card-item-text", 1,  { display: "none", ease: Linear.easeNone}))
                   .add(TweenLite.to(".card-item-text-1", 1,  { display: "block", ease: Linear.easeNone}))
                   .add(TweenLite.fromTo(".card-slide-1", 1, {y: "16%"}, {y: "16%", ease: Linear.easeNone}))  
                   .add(TweenLite.fromTo(".card-slide-1", 1, {y: "16%"}, {y: "-100%", ease: Linear.easeNone}))  
                         
                    .add(TweenLite.to(".card-item-text", 1,  { display: "none", ease: Linear.easeNone}))
                   .add(TweenLite.to(".card-item-text-2", 1,  { display: "block", ease: Linear.easeNone}))
                  .add(TweenLite.to(".card-slide-2", 30,  { css: { scale:0.9 }, ease: Linear.ease }))                    
                  .add(TweenLite.fromTo(".card-slide-2", 1, {y: "12%"}, {y: "-101%", ease: Linear.easeNone}))
                   
                    .add(TweenLite.to(".card-item-text", 1,  { display: "none", ease: Linear.easeNone}))
                   .add(TweenLite.to(".card-item-text-3", 1,  { display: "block", ease: Linear.easeNone}))
                  .add(TweenLite.to(".card-slide-3", 30,  { css: {  scale:0.9 }, ease: Linear.ease }))                  
                  .add(TweenLite.fromTo(".card-slide-3", 1, {y: "8%"}, {y: "-102%", ease: Linear.easeNone}))
                  
                    .add(TweenLite.to(".card-item-text", 1,  { display: "none", ease: Linear.easeNone}))
                    .add(TweenLite.to(".card-item-text-4", 1,  { display: "block", ease: Linear.easeNone}))
                  .add(TweenLite.to(".card-slide-4", 30,  { css: { scale:0.9 }, ease: Linear.ease }))                    
                  .add(TweenLite.fromTo(".card-slide-4", 1, {y: "4%"}, {y: "-103%", ease: Linear.easeNone}))

                          .add(TweenLite.to(".card-item-text", 1,  { display: "none", ease: Linear.easeNone}))
                   .add(TweenLite.to(".card-item-text-5", 1,  { display: "block", ease: Linear.easeNone}))
                  .add(TweenLite.to(".card-slide-5", 30,  { css: { scale:0.9 }, ease: Linear.ease }))
                   
  
                  //.add(TweenLite.fromTo(".card-slide-5", 1, {y: "0%"}, {y: "-104%", ease: Linear.easeNone}));
							// create scene to pin and link animation
							new ScrollMagic.Scene({
									triggerElement: "#GD-88-picture-linkage-container",
									triggerHook: "onLeave",
									duration: "300%"
								})
								.setPin("#GD-88-picture-linkage-container")
								.setTween(wipeCardAnimation)
								.addTo(controllerCard);
                 
  

  //changebg.liquid
     var Gd88_2controller = new ScrollMagic.Controller();
    var t2 = new TimelineMax();
    t2.add([
        TweenLite.to(".zero-one", 1,  { className: "+=trans-Bg-one-left"} ),
        TweenLite.to(".Bg-one-left", 0.5,  { className: "+=trans-Bg-one-left" ,delay:1}),
        TweenLite.to(".blue-wave", 0.5, { css: {display:"none" }}),
        TweenLite.to(".grenn-wave", 0.5, { css: {display:"none" }}),
      ])
      .add([
        TweenLite.to(".Bgtwo-container", 2, { css: {opacity:1 }, ease: Linear.ease }),
        TweenLite.to(".GD-88product-image", 1.5,  { css: {  scale:0.9 } }),
        TweenLite.to(".GD-88product-image", 4, { className:"+=trans-GD-88product-image" }),
        TweenLite.fromTo(".GD-88product-image", 1.5, { rotation: 0 }, { css: { rotation: 30 }})
     // TweenLite.fromTo(".GD-88product-image", 1, { x: "0%" ,rotation: 0 }, { css: { x: "-70%" ,rotation: 30 }})
      ])


 // t2.add([
 //        TweenLite.to(".zero-one", 1,  { css: {opacity:0 } }),
 //        TweenLite.to(".Bg-one-left", 6,  { css: {opacity:0 } }),
 //        TweenLite.to(".blue-wave", 3, { css: {display:"none" }}),
 //        TweenLite.to(".grenn-wave", 3, { css: {display:"none" }})
 //      ])
 //      .add([
 //        TweenLite.to(".Bgtwo-container", 1, { css: {opacity:1 }, ease: Linear.ease }),
 //        TweenLite.to(".GD-88product-image", 1,  { css: {  scale:0.9 } }),
 //        TweenLite.fromTo(".GD-88product-image", 1, { x: "0%" ,rotation: 0 }, { css: { x: "-70%" ,rotation: 30 }})
 //      ])

  
  
    // build scene
   if($(window).width()>1100){
    var scene = new ScrollMagic.Scene({ triggerElement: ".GD-88-changeBg-container",triggerHook: "onCenter", duration: "150%", offset: 540 })
        .setTween(t2)
        .setPin(".GD-88-changeBg-container")
        .addTo(controller);
   }


 
  
}
  
});



$('.qr-wmc-container .more-name li').click(function () {
    let index = $(this).index();
    $(this).addClass('active').siblings().removeClass('active');
    $(`.qr-wmc-container .more-image .img`).each(function () {
        let img_index = $(this).attr('index');
        if (img_index == index) {
            $(this).show().siblings().hide();
        }
    })
})





// $(function () {
//     var $window = $(window);
//     var fadeIn = _.map($('body .js-scroll-fade-in').get(), function (i) {
//         return $(i);
//     });
//     var onScroll = function () {
//         var wtop = $window.scrollTop();
//         if (fadeIn.length > 0) {
//             var wheight = $window.height();
//             var loadedIndex = [];
//             _.each(fadeIn, function ($i, index) {
//                 if ($i.offset().top - wtop < wheight) {
//                     $i.addClass('is_over');
//                     loadedIndex.unshift(index);
//                 }
//             });
//             _.each(loadedIndex, function (index) {
//                 fadeIn.splice(index, 1);
//             });
//         }
//     };
//     $window.scroll(onScroll);
//     onScroll();
// })

$('.show-psb-btn').click(function () {
    $('.qr-detail-product-box').fadeIn();
})
$('.qr-dpb-close-btn').click(function () {
    $('.qr-detail-product-box').fadeOut();
})


if ($('.qr20-desc-container').offset()) {
    $(window).scroll(function () {
        if ($(window).scrollTop()  +($(window).height()) > $('.qr20-desc-container').offset().top) {
            $('.qr-side-buy-btn').show();
        }
        else {
            $('.qr-side-buy-btn').hide();
        }
    });
}

$('.qr-side-buy-btn').click(function () {
    $('#AddToCart').click();
})

let mousewheel_status=false;
function getScroll(){

    function $(x) {
        return document.getElementById(x);
    };
    $('qr-what-more-container').onmousewheel = function scrollWheel(e) {
        var sl;
        e = e || window.event;
        if (navigator.userAgent.toLowerCase().indexOf('msie') >= 0) {
            event.returnValue = false;
        } else {
            e.preventDefault();
        };
        if (e.wheelDelta) {
            sl = e.wheelDelta;
        } else if (e.detail) {
            sl = -e.detail;
        };
      
       if (sl > 0) {
        getMousewheel("up");
        } 
        if (sl < 0) {
        getMousewheel("down");
        } 
    };
    if (navigator.userAgent.toLowerCase().indexOf('firefox') >= 0) {
        //firefox支持onmousewheel
        addEventListener('DOMMouseScroll',
            function(e) {
                var obj = e.target;
                var onmousewheel;
                while (obj) {
                    onmousewheel = obj.getAttribute('onmousewheel') || obj.onmousewheel;
                    if (onmousewheel) break;
                    if (obj.tagName == 'BODY') break;
                    obj = obj.parentNode;
                };
                if (onmousewheel) {
                    if (e.preventDefault) e.preventDefault();
                    e.returnValue = false; 
                    if (typeof obj.onmousewheel != 'function') {
                       
                        eval('window._tmpFun = function(event){' + onmousewheel + '}');
                        obj.onmousewheel = window._tmpFun;
                        window._tmpFun = null;
                    };
                    setTimeout(function() {
                            obj.onmousewheel(e);
                        },
                        1);
                };
            },
            false);
    };
}

function getMousewheel(type){
  let index=$('#qr-wmc-more-name .active').index();
  let length=$('#qr-wmc-more-name li').length;
  if(type=="up"){
    if(index==0){
      $(`#qr-wmc-more-name li:eq(${length-1})`).addClass('active').siblings().removeClass('active');
       $(`.qr-wmc-container .more-image .img[index="${length-1}"]`).show().siblings().hide();
       mousewheel_status=true;
    }
    else{
      $(`#qr-wmc-more-name li:eq(${index-1})`).addClass('active').siblings().removeClass('active');
       $(`.qr-wmc-container .more-image .img[index="${index-1}"]`).show().siblings().hide();
       mousewheel_status=false;
    }
  }
	if(type=="down"){
      if(index==length-1){
        $(`#qr-wmc-more-name li:eq(0)`).addClass('active').siblings().removeClass('active');
        $(`.qr-wmc-container .more-image .img[index="0"]`).show().siblings().hide();
        mousewheel_status=true;
      }
      else{
          $(`#qr-wmc-more-name li:eq(${index+1})`).addClass('active').siblings().removeClass('active');
        $(`.qr-wmc-container .more-image .img[index="${index+1}"]`).show().siblings().hide();
         mousewheel_status=false;
        }
  
  }
}




if ($('.qr-product-specifications-box').offset()) {
    $(window).scroll(function () {
        if (($(window).scrollTop() + $(window).height()) >= $('.qr-product-specifications-box').offset().top) {
        }
     
    });
}


$('.eu-Stock .eu-question').hover(function(){
  let tips=$(this).parent().data('tips');
  if($(this).parent().hasClass('has-stock')){
    let str_html=`<span class="eu-tips-box">${tips}</span>`;
    $(this).after(str_html);
  }
},function(){
$('.eu-tips-box').remove();              
})



// register javascript 
$(function(){
	var isAgree = $('#agreeCheckbox').is(':checked')
    if(isAgree) {
    $('.register-btn').removeClass('disabled').removeAttr('disabled')
  } else {
    $('.register-btn').addClass('disabled').attr("disabled","disabled")
  }
})

$('#agreeCheckbox').click( function() {
   let isChecked = $('#agreeCheckbox').is(':checked')
   if(isChecked) {
    	$('.register-btn').removeClass('disabled').removeAttr('disabled')
  	} else {
    	$('.register-btn').addClass('disabled').attr("disabled","disabled")
  	}
})

// Landing page Sidebar
$('.landing-sidebar .close-btn').click(function(){
  $('.landing-sidebar .sidebar-item-linkbanner').css('display','none');
  $(this).css('display','none');
})
$('.landing-sidebar .sidebar-block-area .sidebar-item').click(function(){
  let target = $(this).data('target');
  $("html, body").animate({
    scrollTop:  $(`#${target}`).offset().top + "px"
  }, 500);
  return false;
});


// click notify btn  to popup window form
$(".notify-btn").click(function(){
  $(".popwindows").removeClass("hide");
  var t =$(this).data("target");
  $(t).show().siblings().hide();
});
$(".popclose-btn").click(function(){$(".popwindows").addClass("hide")});


// click tab btn 
$(".tab-btn").click(function(){
  var t =$(this).data("target");
  $(t).show().siblings(".tab-content").hide();
});
// click  btn  scroll
  $('.link-btn').click(function(){
        let target = $(this).data('target');
     $("html, body").animate({
       scrollTop:  $(`${target}`).offset().top + "px"
  }, 500);
  return false;
   });

if($(".announcement-bar").height() > 0) {
  var announceSwiper = new Swiper('.announcement-bar', {
    autoplay: {
      delay: 5000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-next',
      prevEl: '.swiper-prev',
    },
  })
  //  Scroll Fixed 
     var bar_contain = $(".announcement-container");
  var tbar =$(".announcement-bar");
  console.log("bar_contain.length:"+ bar_contain.length );
  if(bar_contain.length > 0) {
    var bar_height = $(".announcement-bar").height();
    var bar_contain_top =bar_contain.offset().top;
    var p=0,t=0; 
    bar_contain.height(bar_height);
    tbar.css("top",bar_contain_top);
    
  $(window).scroll(function(){ 
  var win_height=$(window).height();
  var  bar_top= bar_contain.offset().top + win_height;
     var p = $(this).scrollTop();  
        if (p > bar_top ){
            if(t<= p){//down  
		      console.log("down");
              $(".announcement-bar").removeClass("fixed-announcement-bar");
            }  
            else{//up  
              console.log("up");
              $(".announcement-bar").addClass("fixed-announcement-bar");
 
            }  
            setTimeout(function(){t = p;},0);  
        }
    
    if(bar_height) {
      if($(window).width() > 1001 && $(".sticky--active.sticky--open").height() > 0) {
        $(".sticky--active.sticky--open").css("top", bar_height +"px");
      }

    } else {
      if($(window).width() > 1001 && $(".sticky--active.sticky--open").height() > 0) {
        $(".sticky--active.sticky--open").css("top", "0");
      }
    }
  })
}
}
if($(".announcement-bar").height() > 0 && $(".announcement-bar .announcement-close-btn").height() > 0) {
  $(".announcement-bar .announcement-close-btn").click(function(){
    if($(".sticky--active.sticky--open").height() > 0) {
      $(".announcement-bar").css("height","0");
      $(".announcement-bar").css("display","none");
      $(".sticky--active.sticky--open").css("top","0"); 
    } else {
      $(".announcement-bar").css("height","0");
      $(".announcement-bar").css("display","none");
    }
  })
}
var interAnnouncement = setInterval(getAnnouncementBox,1000);
var fsb_chajian =false;
function getAnnouncementBox(){
  if ($("#fsb_background").length > 0 ){ 
    var fsb_chajian = true;
  var fsb_h =  $("#fsb_background").height();
     $("#StickyBar").css("top", fsb_h);
    clearInterval(interAnnouncement);
  }
};

$(window).scroll(function(){
  // console.log("fsb_background length :"+$("#fsb_background").length);
  if ($("#fsb_background").length == 0 ){
   $("#StickyBar").css("top", 0); 
  }
});

// Christmas Header Lights
$('.christ-light-image').slick({
  autoplay: true,
  autoplaySpeed: 1000,
  arrows: false,
  dots: false,
  infinite: true,
  speed: 1000,
  fade: true,
  cssEase: 'linear'
});

// 2022 newyear
$(function(){
  $(window).scroll(function(){
    if($(window).scrollTop() +($(window).height())*2/3  > $(".site-footer").offset().top){
      $(".newyear-image2022").addClass("active");
    }else{
      $(".newyear-image2022").removeClass("active");
    }
  }); 
});
// end newyear
// flash page Bottom
if($(".site-footer").height() > 0 && $(".bfcm-bottombar").height() > 0){
  $(window).scroll(function(){
    if($(window).scrollTop() + ($(window).height())*5/6  > $(".site-footer").offset().top){
      $(".bfcm-bottombar").css("position","unset");
    } else {
      $(".bfcm-bottombar").css("position","fixed");
    }
  })
}

// Feedback Modify
$(function(){
  $(".download-page .grid--uniform .grid__item .grid-view-item .grid-view-item__imageoverlap").click(function(){
    $(this).siblings(".download-notice").css("display", "block");
    $(this).siblings(".download-notice").css("opacity", "0");
    setTimeout(() => {
               var elMain = ($(this).siblings(".download-notice").find(".download-main"))[0];
    var elMainHeight = elMain.scrollHeight
    var elScroll = $(this).siblings(".download-notice").find(".download-scroll");
    var elScrollHeight = elScroll.height();
    var elHeader = $(this).siblings(".download-notice").find(".download-title");
    var elHeaderHeight = elHeader.height();
    var elDownloadBox = $(this).siblings(".download-notice").find(".download-box");
    var boxHeight = 0;
    if(elMainHeight > elScrollHeight){
      elScroll.parent(".scroll-pos").addClass("scroll-abled");
    }else {
      if($(window).width() > 791) {
        elScroll.css("height", elMainHeight +"px");
        boxHeight = elMainHeight + elHeaderHeight + 90;
        elDownloadBox.css("height", boxHeight +"px");
      }else if($(window).width() <590){
        elScroll.css("height", elMainHeight +"px");
        boxHeight = elMainHeight + elHeaderHeight + 60;
        elDownloadBox.css("height", boxHeight +"px");
      }else {
        elScroll.css("height", elMainHeight +"px");
        boxHeight = elMainHeight + elHeaderHeight + 75;
        elDownloadBox.css("height", boxHeight +"px");
      }
    }
    $(this).siblings(".download-notice").css("opacity", "1");
  }, 20);
});
$(".download-page .grid--uniform .grid__item .grid-view-item .grid-view-item__title").click(function(){
  $(this).siblings(".download-notice").css("display", "block");
  $(this).siblings(".download-notice").css("opacity", "0");
  setTimeout(() => {
             var elMain = ($(this).siblings(".download-notice").find(".download-main"))[0];
  var elMainHeight = elMain.scrollHeight
  var elScroll = $(this).siblings(".download-notice").find(".download-scroll");
  var elScrollHeight = elScroll.height();
  var elHeader = $(this).siblings(".download-notice").find(".download-title");
  var elHeaderHeight = elHeader.height();
  var elDownloadBox = $(this).siblings(".download-notice").find(".download-box");
  var boxHeight = 0;
  if(elMainHeight > elScrollHeight){
    elScroll.parent(".scroll-pos").addClass("scroll-abled");
  }else {
    if($(window).width() > 791) {
      elScroll.css("height", elMainHeight +"px");
      boxHeight = elMainHeight + elHeaderHeight + 90;
      elDownloadBox.css("height", boxHeight +"px");
    }else if($(window).width() <590){
      elScroll.css("height", elMainHeight +"px");
      boxHeight = elMainHeight + elHeaderHeight + 60;
      elDownloadBox.css("height", boxHeight +"px");
    }else {
      elScroll.css("height", elMainHeight +"px");
      boxHeight = elMainHeight + elHeaderHeight + 75;
      elDownloadBox.css("height", boxHeight +"px");
    }
  }
  $(this).siblings(".download-notice").css("opacity", "1");
}, 20);
});
$(".download-notice .download-header").click(function(event){
  event.stopPropagation();
  $(".download-page .download-notice").css("display", "none");
});
});
$(function(){
  // Download Select
  var downloadLen = $(".download-page .download-section .grid--view-items .grid__item").length;
  if(downloadLen){
    var clickedValue = $(".download-search-bar .download-lists #radio-click").val();
    if(clickedValue == 'all') {
      $(`.download-page .download-section`).css("display", "block");
    }else {
      $(`.download-page .download-section`).css("display", "none");
      $(`.download-page .${clickedValue}`).css("display", "block");
    }
    search(downloadLen);
    $(".download-search-bar .download-lists #radio-click").change(function(){
      var clickedValue = $(this).val();
      if(clickedValue == 'all') {
        $(`.download-page .download-section`).css("display", "block");
      }else {
        $(".download-page .download-section").css("display", "none");
        $(`.download-page .${clickedValue}`).css("display", "block");
      }
      search(downloadLen);
    });
    // Download Search
    $(".download-search-bar .searchall-box #dowload_search_all #search_btn").click(function(){
      search(downloadLen);
    });
    $(".download-search-bar .searchall-box #dowload_search_all #searchall").keypress(function(e) {
      if(e.which == 13) {
        search(downloadLen);
      }
    });
    function search(downloadLen) {
      var str = $(".download-search-bar .searchall-box #dowload_search_all #searchall").val().trim().toLowerCase();
      if(str == '') {
        $(`.download-page .download-section`).css("display", "block");
        //             $(".download-page .download-section .grid--view-items .type-title").css("display", "block");
        $(".download-page .download-section .type-title").css("display", "block");
        $(".download-page .download-section .grid--view-items .grid__item").css("display", "block");
        $(".download-page .download-search-bar .search-tips").removeClass("active");
      }else {
        //       $(".download-page .download-section .grid--view-items .type-title").css("display", "none");
        $(".download-page .download-section .type-title").css("display", "none");
        for(let i = 0; i<downloadLen; i++) {
          var tempStr = $(".download-page .download-section .grid--view-items .grid__item .grid-view-item__title p").eq(i).text().toLowerCase();
          if(tempStr.indexOf(str) != -1) {
            $(".download-page .download-section .grid--view-items .grid__item").eq(i).siblings(".type-title").css("display", "block");
            $(".download-page .download-section .grid--view-items .grid__item").eq(i).parent().siblings(".type-title").css("display", "block");
            $(".download-page .download-section .grid--view-items .grid__item").eq(i).css("display", "block");
            $(".download-page .download-search-bar .search-tips").removeClass("active");
          }else {
            $(".download-page .download-section .grid--view-items .grid__item").eq(i).css("display", "none");
          }
        }
      }
      var clickedValue = $(".download-search-bar .download-lists #radio-click").val();
      if(clickedValue == 'all') {
        $(`.download-page .download-section`).css("display", "block");
      }else {
        $(".download-page .download-section").css("display", "none");
        $(`.download-page .${clickedValue}`).css("display", "block");
      }
    }
  }
});
$("body").click(function(event){
  if($(event.target).closest(".download-notice").length && $(event.target).closest(".scroll-pos").length == 0 && $(event.target).closest(".download-title").length == 0){
    $(event.target).closest(".download-notice").css("display", "none");
  }
});

// 10th

if($("body").hasClass("template-10th-anniversary")){
$(function(){
  $('.video-button').on('click', function () {
    $("#video-placeholder").css("visibility","visible");
    player.playVideo();
    $(this).css("display","none");
  });

  if($(window).width() <= 1280){
    $('.video-button').on('click', function () {
      $('.k10th-banner .medium-up-hide').attr("style","display:none !important");
      $('.k10th-banner #video-placeholder').attr("style","display:block;min-height:400px;position: relative;top: unset;left: unset;transform: none;width: 100%;height: unset;");
    });
  }
  
  $(function(){
    if($(".img-box-anniversary-04").length > 0 ){
    $(window).scroll(function(){
      if($(window).scrollTop() +($(window).height())*2/3  > $(".img-box-anniversary-04").offset().top){
        $(".anniversary-04-10th-box-mrp").addClass("active");
      }else{
        $(".anniversary-04-10th-box-mrp").removeClass("active");
      }
    }); 
    }
  });

  $(function() {
    $(".anniversary-10-topbar-kei ul li a").click(function(e) {
      e.preventDefault();
      var hash = this.hash.substr(1);
      $('html, body').animate({
        scrollTop: $("#" + hash).offset().top - $(".anniversary-10-topbar-kei").height()
      }, 500);
    });

    $(window).scroll(function() {
			var wrapper_height = $("#shopify-section-anniversary-keibar-10th").height();
			var top = $(this).scrollTop();
			$(".container-10th-anniversary .anniversary-section").each(function(i) {
        var color =$(this).find(".color-box").data("color");
				var this_top = $(this).offset().top;
				var height = $(this).height();
				var this_bottom = this_top + height;
				var percent = 0;
				if (top >= this_top && top <= this_bottom) {
					percent = ((top - this_top) / (height - wrapper_height)) * 100;
          $("#shopify-section-anniversary-keibar-10th li:eq(" + i + ") span").parent().addClass("activeuuu").siblings().removeClass("activeuuu");
          $("#shopify-section-anniversary-keibar-10th .wap-topbarkei li:eq(" + i + ") span").parent().addClass("activeuuu").siblings().removeClass("activeuuu");
				} else if (top > this_bottom) {
					percent = 100;
					// $("#shopify-section-anniversary-keibar-10th li:eq(" + i + ") i").css("color", "#fff");
				}


        // $("#shopify-section-anniversary-keibar-10th li:eq(" + i + ") span").css("background-color", color );
				$("#shopify-section-anniversary-keibar-10th li:eq(" + i + ") span").css("width", percent + "%");
        $("#shopify-section-anniversary-keibar-10th .wap-topbarkei li:eq(" + i + ") span").css("width", percent + "%");

        if ($(document).height() == $(window).scrollTop() + $(window).height()) {
          $("#shopify-section-anniversary-keibar-10th li span").css("width", "100%");
          $("#shopify-section-anniversary-keibar-10th .wap-topbarkei li span").css("width", percent + "%");
        }

      });

      

		});



  });

if($("#navtogglekei").length > 0 ){
  document.getElementById('navtogglekei').addEventListener('click', function () {
    let topbarul = document.getElementsByClassName(' annikmekei')[0];
    if (this.classList.contains('nav-toggle--expanded')) {
      this.classList.remove('nav-toggle--expanded');
      topbarul.classList.remove('nav--expanded');
    } else {
      this.classList.add('nav-toggle--expanded');
      topbarul.classList.add('nav--expanded');
    }
  });
}


  window.addEventListener("scroll", function(event)
    {
        event = event || window.event;

        var scrollTop = $(this).scrollTop();   
        // console.log("$(this).scrollTop()=" + $(this).scrollTop());

        var documentHeight = $(document).height();  
        // console.log("$(document).height()=" + $(document).height());

        var windowHeight = $(window).height();    
        // console.log("$(window).height()=" + $(window).height());

        var page3Height = $("#shopify-section-anniversary-03-10th").offset().top;
        // console.log($("#shopify-section-anniversary-03-10th").offset().top);
        var page3Heightchaj = documentHeight - scrollTop;
        if( scrollTop > page3Height ){
            $("#shopify-section-anniversary-keibar-10th ").css("position","fixed");
            $("#shopify-section-anniversary-keibar-10th ").css("display","block");
        }else{
            $("#shopify-section-anniversary-keibar-10th ").css("position","relative");
            $("#shopify-section-anniversary-keibar-10th ").css("display","none");
        }
        
   });

   if ($("#copy10thcode").length > 0) {
    var btn = document.querySelector('#copy10thcode');
    var btnsvg = document.querySelector('#copysvgdiv');
    btn.addEventListener('click', () => {
      const textCopied = ClipboardJS.copy(document.querySelector('#coupon10th'));
      console.log('copied!', textCopied);
      btnsvg .innerHTML =
        '<svg width="18" height="18" class="icon icon-check copyfinish" viewBox="0 -65 434.67733 434"  xmlns="http://www.w3.org/2000/svg"><path d="m152.003906 304.34375c-5.460937 0-10.921875-2.089844-15.082031-6.25l-130.664063-130.667969c-8.34375-8.339843-8.34375-21.824219 0-30.164062 8.339844-8.339844 21.820313-8.339844 30.164063 0l115.582031 115.582031 246.253906-246.25c8.339844-8.339844 21.820313-8.339844 30.164063 0 8.339844 8.34375 8.339844 21.824219 0 30.167969l-261.332031 261.332031c-4.160156 4.160156-9.625 6.25-15.085938 6.25zm0 0"/></svg>'
    })
  }

  // 10-10th.liquid
     if ($(".swiper-container-anniversary").length > 0) {
      console.log("you");
  var hyswiperss = new Swiper('.swiper-container-anniversary', {
		//   loop : true,
		speed: 20000,
		freeMode: true,
		//  loop:true,
		slidesPerView: 2,
		slidesPerColumn: 2,
		autoplay: {
			delay: 0,
		},
		spaceBetween: 30,
		breakpoints: {
			801: {
				slidesPerView: 2,
				slidesPerColumn: 2,
			},
			500: {
				slidesPerView: 1,
				slidesPerColumn: 2,
			},
		},
		on: {
			slideChangeTransitionEnd: function() {
				var end = this.isEnd;
				if (end) {
					setTimeout(function() {

						hyswiperss.slideTo(0, 1000, false)
					}, 100)
				}
			},
		},
	});
	hyswiperss.el.onmouseover = (function() {
		hyswiperss.autoplay.stop();
	})

	hyswiperss.el.onmouseout = (function() {
		hyswiperss.autoplay.start();
	})

     }

  
  
})
}


if($("body").hasClass("template-10th-review-page")){
  $(function(){
    $(".a10th-review-bar ul li a").click(function(o) {
      o.preventDefault();
      var hash = this.hash.substr(1);
      if($(".10review-fsbheight").length > 0){
        $('html, body').animate({
          scrollTop: $("#" + hash).offset().top - $(".a10th-review-bar").height() - $(this).height()
        }, 500);
      }else{
        $('html, body').animate({
          scrollTop: $("#" + hash).offset().top - $(".a10th-review-bar").height()
        }, 500);
      }
      
    });

    $(window).scroll(function() {
      var wrapper_height = $(".a10th-review-bar-div").height();
      var top = $(this).scrollTop();
      $(".template-10th-review-page .anni-review-section").each(function(i,e) {
       
        var color =$(this).find(".topbarkei-color").data("color");
        var this_top = $(this).offset().top;
        var height = $(this).height();
        var this_bottom = this_top + height;
        var percent = 0;
        if (top >= this_top && top <= this_bottom) {
          percent = ((top - this_top) / (height - wrapper_height)) * 100;
          $(".a10th-review-bar-div .topbarulkei li:eq(" + i + ") span").parent().addClass("activeuuu").siblings().removeClass("activeuuu");
          //$(".a10th-review-bar-div .wap-topbarkei li:eq(" + i + ") span").parent().addClass("activeuuu").siblings().removeClass("activeuuu");
        } else if (top > this_bottom) {
          percent = 100;
          // $(".a10th-review-bar-div li:eq(" + i + ") i").css("color", "#fff");
        }

      if(top >= this_top){
        $(".a10th-review-bar-div .topbarulkei li:eq("+i+") span").parent().prevAll("li").find("span").css("background-color", color );
      
      }

        $(".a10th-review-bar-div .topbarulkei li:eq("+i+") span").css("background-color", color );

        
        
        
        if($(".topbarulli-5 span").width() > $(".topbarulli-5").width() / 2  && $(".topbarulli-7 span").width() <= 0){
          // console.log($(".topbarulli-5 span").width());
          $(".a10th-review-bar-div .topbarulkei .topbarulli-5 span").css("background-color", "#df8c10" );
          $(".a10th-review-bar-div .topbarulkei .topbarulli-5 span").parent().prevAll("li").find("span").css("background-color", "#df8c10" );
        }

        if($(".topbarulli-8 span").width() > $(".topbarulli-8").width() / 2  && $(".topbarulli-10 span").width() <= 0){
          // console.log($(".topbarulli-8 span").width());
          $(".a10th-review-bar-div .topbarulkei .topbarulli-8 span").css("background-color", "#A11B23" );
          $(".a10th-review-bar-div .topbarulkei .topbarulli-8 span").parent().prevAll("li").find("span").css("background-color", "#A11B23" );
        }

        $(".a10th-review-bar-div .topbarulkei li:eq(" + i + ") span").css("width", percent + "%");
        //$(".a10th-review-bar-div .wap-topbarkei li:eq(" + i + ") span").css("width", percent + "%");
        
        if ($(document).height()  == $(window).scrollTop() + $(window).height()) {
	            $(".a10th-review-bar-div .topbarulkei li span").css("width", "100%");
				$(".a10th-review-bar-div .topbarulkei .topbarulli-10 span").parent().prevAll("li").find("span").css("background-color", "#df8c10" );
	    }
        
      });
    });

    // $(".template-10th-review-page .a10th-review-picdesc-bigbox").each(function(p) {

    //   var iwidth = $('.a10th-review-bar ul li:eq(' + p + ')').width();
    //   $('.a10th-review-bar ul li:eq(' + p + ') p').css("width", iwidth + 'px');
      
    // });

    $(".template-10th-review-page .resetheight_10th").each(function(j) {
      let that=$(this);

      if( that.width() / 2.4 > that.height()){
        that.height(that.width() * 0.85);
      }
        
    });

    $(window).resize(function(){
      $(".template-10th-review-page .resetheight_10th").each(function() {
        let that=$(this);
  
        if( that.width() / 3 > that.height()){
          that.height(that.width() * 0.85);
        }
          
      });
    })

    window.addEventListener("scroll", function(event)
    {
        event = event || window.event;

        var scrollTop = $(this).scrollTop();   
        // console.log("$(this).scrollTop()=" + $(this).scrollTop());

        var documentHeight = $(document).height();  
        // console.log("$(document).height()=" + $(document).height());

        var windowHeight = $(window).height();    
        // console.log("$(window).height()=" + $(window).height());
        var a10thbartop = $(".a10th-review-bar-div").height();
        var page3Height = $(".a10th-review-1-barbottom").offset().top;
        // console.log($("#shopify-section-anniversary-03-10th").offset().top);
        var page3Heightchaj = documentHeight - scrollTop;
        if($(".10review-fsbheight").length > 0){
          if( scrollTop + a10thbartop +5 + $(".10review-fsbheight").height() > page3Height ){
            $(".a10th-review-bar-div ").css("position","fixed");
            $(".a10th-review-bar-div").css("display","block");
          }else{
            $(".a10th-review-bar-div").css("position","relative");
            $(".a10th-review-bar-div").css("display","none");
          }
        }else{
          if( scrollTop + a10thbartop +2 > page3Height ){
            $(".a10th-review-bar-div ").css("position","fixed");
            $(".a10th-review-bar-div").css("display","block");
          }else{
              $(".a10th-review-bar-div").css("position","relative");
              $(".a10th-review-bar-div").css("display","none");
          }
        }
        
   });
  });
}

// GD-88 display-detail
$(function(){
       $(".GD-88detail_btn").on("click",function(){
        // console.log("11")
        $(".outer_boxshadow").css("display","block");
      })
      $(".detail_close").on("click",function(){
           // console.log("11")
        $(".outer_boxshadow").css("display","none")
      })

    })
  if (window.navigator.userAgent.indexOf("Firefox")>=1){
  
    // $(".container-top>p:nth-child(1)").addClass("firefoxP")
    
    if(document.querySelector(".container-top>p:nth-child(1)")){
      document.querySelector(".container-top>p:nth-child(1)").classList.add("firefoxP");
    }
    // document.querySelector(".container-top>p:nth-child(1)").classList.add("firefoxP");
  }


  //// fixed product limit inventroy quantity tips
  $(function(){
$(".close-btn").click(function(){
  $(".error-popup").fadeOut();
});
  });

  $( document ).ready(function() {
    if($(window).width() > 1000){

    const table1 = document.querySelector('.amz_spec_table:first-child');
    const table2 = document.querySelector('.amz_spec_table:last-child');
    const numRows1 = table1.rows.length;
    const numRows2 = table2.rows.length;
    
    let maxRows = Math.max(numRows1, numRows2);
    const table1Rows = document.querySelectorAll('.amz_spec_table:first-child tr');
    const table2Rows = document.querySelectorAll('.amz_spec_table:last-child tr');

    for (let i = 0; i < maxRows; i++) {
      const table1Row = table1.rows[i];
      const table2Row = table2.rows[i];

      let maxHeight = 0;

      const table1RowHeight = table1Row.clientHeight;
      const table2RowHeight = table2Row.clientHeight;

      maxHeight = Math.ceil(Math.max( table1RowHeight, table2RowHeight));
      // console.log('table1RowHeight:',table1RowHeight,'table2RowHeight:',table2RowHeight,'maxHeight:',maxHeight)

      table1Row.style.height = maxHeight + 'px';
      table2Row.style.height = maxHeight + 'px';
    }
  }
    })


  // amz table show and hide function
  $( document ).ready(function() {
  const amz_table = document.querySelector('.rte__table-wrapper.table')
  const amz_tr = document.querySelectorAll('.amz_spec_table tr')
  let amz_show_flag = false
  const amz_table_btn_div = document.createElement('div')
  
  function hideAmzTable() {
      if(amz_tr.length > 11 ){
          for(let i = 11;i<amz_tr.length;i++){
              amz_tr[i].style.display = 'none';
          }
          amz_table_btn_div.classList.add('amz-hide')
          amz_table_btn_div.innerHTML = `<a class="amz-table-btn">Show Full Specs</a>`
          $(amz_table_btn_div).insertAfter(amz_table);
          // amz_table.append(amz_table_btn_div)
      }
      amz_show_flag = false
  }
  if($(window).width() < 1000){
    hideAmzTable()
    
  }
  const amz_table_btn = document.querySelector('a.amz-table-btn')
  amz_table_btn.addEventListener('click',() => {
      if(!amz_show_flag){
          for(let i = 0;i< amz_tr.length;i++){
              amz_tr[i].style.display = 'table-row';
          }
          amz_show_flag = true
          amz_table_btn_div.style.display = 'none'
      }else{
          hideAmzTable()
      }
  })
})
